export const EVENTS = [
  {
    event: 'Open discussion',
    type: 'Consultation',
    mechanism: 'CEDAW',
    date: new Date(2022, 10, 18)
  },
  {
    event: 'Mid-year report to parliament',
    type: 'Other',
    mechanism: 'All',
    date: new Date(2022, 10, 18)
  },
  {
    event: 'Submission of State report',
    type: 'State reporting',
    mechanism: 'CEDAW',
    date: new Date(2022, 10, 18)
  },
  {
    event: 'Publication of List of Issues',
    type: 'State reporting',
    mechanism: 'CRC',
    date: new Date(2022, 10, 18)
  },
  {
    event: 'Request for comments',
    type: 'Stakeholder reporting',
    mechanism: 'CEDAW',
    date: new Date(2022, 10, 18)
  },
];

export const SPECIAL_PROCEDURES = [
  {
    mandate_holders: 'SR on freedom of expression',
    status_of_visit: 'Reported/Completed',
    status_of_visit_link: 'https://google.com',
    dates: 'from 25 May 1999 to 28 May 1999',
  },
  {
    mandate_holders: 'SR on sale of children',
    status_of_visit: 'Reported/Completed',
    status_of_visit_link: 'https://google.com',
    dates: 'from 29 May 2000 to 2 June 2000',
  },
  {
    mandate_holders: 'SR on migrants',
    status_of_visit: 'Proposal of Dates',
    status_of_visit_link: '',
    dates: '',
  },
  {
    mandate_holders: 'WG on business and HR',
    status_of_visit: 'Inactive',
    status_of_visit_link: '',
    dates: '',
  },
];

export const COUNTRIES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei ",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Côte d'Ivoire",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Congo-Brazzaville)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czechia (Czech Republic)",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini (fmr. 'Swaziland')",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holy See",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar (formerly Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine State",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States of America",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const LANGUAGES = [
  'English',
  'Sweden',
  'Français',
  'Español',
  'русский',
  'العربية'
];

export const INSTITUTIONS = [
  {
    id: 0,
    name: 'OHCHR',
    acronym: 'OHCHR',
    institutionType: 'External'
  },
  {
    id: 1,
    name: 'Ministry of Social Affairs',
    acronym: 'MOSA',
    institutionType: 'Ministry'
  },
  {
    id: 2,
    name: 'Ministry of Political and Public Affairs',
    acronym: 'MOPPA',
    institutionType: 'Ministry'
  },
  {
    id: 3,
    name: 'Ministry of Labour and Social Security',
    acronym: 'MOLSS',
    institutionType: 'Ministry'
  },
  {
    id: 4,
    name: 'Ministry of Justice',
    acronym: 'MoJ',
    institutionType: 'Ministry'
  },
  {
    id: 5,
    name: 'Ministry of Health and Sanitation',
    acronym: 'MOHAS',
    institutionType: 'Ministry'
  },
  {
    id: 6,
    name: 'Ministry of Finance',
    acronym: 'MOF',
    institutionType: 'Ministry'
  },
  {
    id: 7,
    name: 'Ministry of Education',
    acronym: 'MoE',
    institutionType: 'Ministry'
  },
  {
    id: 8,
    name: 'Ministry of Gender',
    acronym: 'MG',
    institutionType: 'Ministry'
  },
  {
    id: 9,
    name: 'Ministry of Foreign Affairs',
    acronym: 'MFA',
    institutionType: 'Ministry'
  },
  {
    id: 10,
    name: 'Department of Corrections and Rehabilitation',
    acronym: '',
    institutionType: 'Internal'
  },
  {
    id: 11,
    name: 'Ministry of Justice (Department of legal affairs)',
    acronym: '',
    institutionType: 'Ministry'
  },
  {
    id: 12,
    name: 'Office of the Ombudsman',
    acronym: '',
    institutionType: 'External'
  },
  {
    id: 13,
    name: 'Parliament',
    acronym: '',
    institutionType: 'Internal'
  }
];

export const INSTITUTION_TYPES = [
  'External',
  'Internal',
  'Ministry'
];

export const USERS = [
  {
    id: 0,
    role: 'Admin',
    institution: 'OHCHR',
    language: 'Français',
    firstName: 'Amelie',
    lastName: 'Rols',
    email: 'intern.rols@ohchr.org',
    username: 'Rols_Test',
    password: '',
    country: COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)],
  },
  {
    id: 1,
    role: 'Lead user',
    institution: 'OHCHR',
    language: 'Español',
    firstName: 'Karin',
    lastName: 'Friedrich',
    email: 'kfriedrich@ohchr.org',
    username: 'cbp_ohchr_KF',
    password: '',
    country: COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)],
  },
  {
    id: 2,
    role: 'Implementation user',
    institution: 'Ministry of Labour and Social Security',
    language: 'русский',
    firstName: 'Merle',
    lastName: 'Jasper',
    email: 'hrtb-cbpconsultant@ohchr.org',
    username: 'Rols_Test',
    password: '',
    country: COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)],
  },
  {
    id: 3,
    role: 'Admin',
    institution: 'Ministry of Finance',
    language: 'English',
    firstName: 'UNDP Pakistan',
    lastName: 'UNDP',
    email: 'nrtdsupport@ohchr.org',
    username: 'UNDP Pakistan',
    password: '',
    country: COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)],
  },
];

export const ROLES = ['Admin', 'Lead user', 'Implementation user'];


export const AFFECTED_PERSONS = [
  {
    name: 'IDPs'
  },
  {
    name: 'Children'
  },
  {
    name: 'Children in vulnerable situations (abused, living on the street, institutionalized, indigenous, migrant children etc.)'
  },
  {
    name: 'Civil society'
  },
  {
    name: 'Disappeared persons'
  },
  {
    name: 'Domestic workers'
  },
  {
    name: 'Educational staff & students'
  },
  {
    name: 'Human rights defenders & activists'
  },
  {
    name: 'Indigenous peoples'
  },
  {
    name: 'Internally displaced persons'
  },
  {
    name: 'Judges, lawyers and prosecutors'
  },
  {
    name: 'Law enforcement / police & prison officials'
  },
  {
    name: 'Lesbian, gay, bisexual and transgender and intersex persons (LGBTI)'
  },
  {
    name: 'Media'
  },
  {
    name: 'Medical staff / health professionals'
  },
  {
    name: 'mercenaries'
  },
  {
    name: 'Migrants'
  },
  {
    name: 'Military personnel'
  },
  {
    name: 'Minorities/ racial, ethnic, linguistic, religious or descent-based groups'
  },
  {
    name: 'Non-citizens'
  },
  {
    name: 'Older persons'
  },
  {
    name: 'People of African Descent'
  },
  {
    name: 'Persons affected by armed conflict'
  },
  {
    name: 'Persons deprived of their liberty & detainees'
  },
  {
    name: 'Persons living in poverty'
  },
  {
    name: 'Persons living in rural areas'
  },
  {
    name: 'Persons living with albinism'
  },
  {
    name: 'Persons living with HIV/AIDS'
  },
  {
    name: 'Persons with disabilities'
  },
  {
    name: 'prison officials'
  },
  {
    name: 'private security'
  },
  {
    name: 'Public officials'
  },
  {
    name: 'Refugees & asylum seekers'
  },
  {
    name: 'Roma, Gypsies, Sinti & Travellers'
  },
  {
    name: 'rural women'
  },
  {
    name: 'Social workers'
  },
  {
    name: 'Stateless persons'
  },
  {
    name: 'Vulnerable persons/groups'
  },
  {
    name: 'Women & girls'
  },
];

export const MECHANISM_TYPES = [
  { id: 1, name: 'Treaty bodies' },
  { id: 3, name: 'Special procedures' },
  { id: 5, name: 'Universal Periodic Review' },
  { id: 7, name: 'Others' }
];

export const CURRENCIES = [
  { id: 88, name: '$' },
  { id: 33, name: 'Euforia £' },
  { id: 9, name: 'SEK' },
];

export const THEMES = [
  { id: 0, parentName: 'General framework of implementation', name: 'Inter-State cooperation and assistance' },
  { id: 1, parentName: 'General framework of implementation', name: 'Cooperation with human rights mechanisms & requests for technical assistance' },
  { id: 2, parentName: 'General framework of implementation', name: 'Human rights education, trainings and awareness raising' },
  { id: 3, parentName: 'General framework of implementation', name: 'Context, statistics, budget, civil society' },
  { id: 4, parentName: 'General framework of implementation', name: 'Scope of international obligations' },
  { id: 5, parentName: 'General framework of implementation', name: 'Legal and institutional reform' },
  { id: 6, parentName: 'General framework of implementation', name: 'Legal & institutional reform' },
  { id: 7, parentName: 'General framework of implementation', name: 'Cooperation & Follow up with Treaty Bodies' },
  { id: 8, parentName: 'General framework of implementation', name: 'Human rights education, trainings & awareness raising' },
  { id: 9, parentName: 'General framework of implementation', name: 'Cooperation & follow up with the Universal Periodic Review (UPR)' },
  { id: 10, parentName: 'General framework of implementation', name: 'Cooperation & Follow up with Special Procedures' },
  { id: 11, parentName: 'General framework of implementation', name: 'Independent Monitoring Mechanism (IMM)' },
  { id: 12, parentName: 'General framework of implementation', name: 'Follow-up to special procedures' },
  { id: 13, parentName: 'General framework of implementation', name: 'Cooperation with other international mechanisms and institutions' },
  { id: 14, parentName: 'General framework of implementation', name: 'National Mechanisms for Reporting & Follow-up (NMRF)' },
  { id: 15, parentName: 'General framework of implementation', name: 'Cooperation with treaty bodies' },
  { id: 16, parentName: 'General framework of implementation', name: 'Follow-up to treaty bodies' },
  { id: 17, parentName: 'General framework of implementation', name: 'Cooperation with the Universal Periodic Review (UPR)' },
  { id: 18, parentName: 'General framework of implementation', name: 'Cooperation with international organizations' },
  { id: 19, parentName: 'General framework of implementation', name: '2030 Agenda & other voluntary commitments' },
  { id: 20, parentName: 'General framework of implementation', name: 'Cooperation with special procedures' },
  { id: 21, parentName: 'General framework of implementation', name: 'Follow-up to Universal Periodic Review (UPR)' },
  { id: 22, parentName: 'General framework of implementation', name: 'Awareness raising and dissemination' },
  { id: 23, parentName: 'General framework of implementation', name: 'Human rights education - general' },
  { id: 24, parentName: 'General framework of implementation', name: 'Professional training in human rights' },
  { id: 25, parentName: 'General framework of implementation', name: 'Human rights education - in schools' },
  { id: 26, parentName: 'General framework of implementation', name: 'Cooperation & consultation with civil society' },
  { id: 27, parentName: 'General framework of implementation', name: 'Data collection & research' },
  { id: 28, parentName: 'General framework of implementation', name: 'Research & other measures of implementation' },
  { id: 29, parentName: 'General framework of implementation', name: 'Budget & resources (for human rights implementation)' },
  { id: 30, parentName: 'General framework of implementation', name: 'Reservations' },
  { id: 31, parentName: 'General framework of implementation', name: 'Ratification of & accession to international instruments' },
  { id: 32, parentName: 'General framework of implementation', name: 'Derogation & state of emergency' },
  { id: 33, parentName: 'General framework of implementation', name: 'Good governance & corruption' },
  { id: 34, parentName: 'General framework of implementation', name: 'National Human Rights Action Plans (or specific areas) / implementation plans' },
  { id: 35, parentName: 'General framework of implementation', name: 'Institutions & policies - General' },
  { id: 36, parentName: 'General framework of implementation', name: 'Constitutional & legislative framework' },
  { id: 37, parentName: 'General framework of implementation', name: 'National Human Rights Institution (NHRI)' },
  { id: 38, parentName: 'General framework of implementation', name: 'National Preventive Mechanism (NPM)' },
  { id: 39, parentName: 'General framework of implementation', name: 'Human rights policies' },
  { id: 40, parentName: 'Universal or cross-cutting issues', name: 'Business & Human Rights' },
  { id: 41, parentName: 'Universal or cross-cutting issues', name: 'Equality and non-discrimination' },
  { id: 42, parentName: 'Universal or cross-cutting issues', name: 'International criminal and humanitarian law' },
  { id: 43, parentName: 'Universal or cross-cutting issues', name: 'Human rights & use of mercenaries' },
  { id: 44, parentName: 'Universal or cross-cutting issues', name: 'Human rights & counter-terrorism' },
  { id: 45, parentName: 'Universal or cross-cutting issues', name: 'Human rights and environmental issues' },
  { id: 46, parentName: 'Universal or cross-cutting issues', name: 'Right to development' },
  { id: 47, parentName: 'Universal or cross-cutting issues', name: 'Right to self-determination' },
  { id: 48, parentName: 'Universal or cross-cutting issues', name: 'Right to a remedy' },
  { id: 49, parentName: 'Universal or cross-cutting issues', name: 'Unilateral coercive measures' },
  { id: 50, parentName: 'Universal or cross-cutting issues', name: 'Economic & political crisis, natural disasters or other emergencies' },
  { id: 51, parentName: 'Universal or cross-cutting issues', name: 'Equality & non-discrimination' },
  { id: 52, parentName: 'Universal or cross-cutting issues', name: 'Racial discrimination' },
  { id: 53, parentName: 'Universal or cross-cutting issues', name: 'Crimes against humanity' },
  { id: 54, parentName: 'Universal or cross-cutting issues', name: 'Genocide' },
  { id: 55, parentName: 'Universal or cross-cutting issues', name: 'International criminal & humanitarian law (including crimes against humanity, war crimes, genocide)' },
  { id: 56, parentName: 'Universal or cross-cutting issues', name: 'Human rights & the environment' },
  { id: 57, parentName: 'Universal or cross-cutting issues', name: 'Human rights & climate change' },
  { id: 58, parentName: 'Universal or cross-cutting issues', name: 'Human rights & toxics / hazardous wastes' },
  { id: 59, parentName: 'Universal or cross-cutting issues', name: 'Right to development' },
  { id: 60, parentName: 'Universal or cross-cutting issues', name: 'Economic policy and foreign debt' },
  { id: 61, parentName: 'Universal or cross-cutting issues', name: 'Right to self-determination' },
  { id: 62, parentName: 'Universal or cross-cutting issues', name: 'Rule of law & impunity' },
  { id: 63, parentName: 'Universal or cross-cutting issues', name: 'Support to victims & witnesses' },
  { id: 64, parentName: 'Universal or cross-cutting issues', name: 'Access to justice & remedy' },
  { id: 65, parentName: 'Universal or cross-cutting issues', name: 'Transitional justice' },
  { id: 66, parentName: 'Civil & political rights', name: 'Right to physical & moral integrity' },
  { id: 67, parentName: 'Civil & political rights', name: 'Rights related to name, identity & nationality' },
  { id: 68, parentName: 'Civil & political rights', name: 'Rights related to marriage & family' },
  { id: 69, parentName: 'Civil & political rights', name: 'Fundamental freedoms' },
  { id: 70, parentName: 'Civil & political rights', name: 'Liberty & security of the person' },
  { id: 71, parentName: 'Civil & political rights', name: 'Administration of justice' },
  { id: 72, parentName: 'Civil & political rights', name: 'Right to participate in public affairs & right to vote' },
  { id: 73, parentName: 'Civil & political rights', name: 'Civil & political rights - general measures of implementation' },
  { id: 74, parentName: 'Civil & political rights', name: 'Use of mercenaries/private security' },
  { id: 75, parentName: 'Civil & political rights', name: 'Ill-treatment (including cruel, inhuman or degrading treatment)' },
  { id: 76, parentName: 'Civil & political rights', name: 'Death penalty' },
  { id: 77, parentName: 'Civil & political rights', name: 'Right to life' },
  { id: 78, parentName: 'Civil & political rights', name: 'Human trafficking & contemporary forms of slavery' },
  { id: 79, parentName: 'Civil & political rights', name: 'Sexual & gender-based violence' },
  { id: 80, parentName: 'Civil & political rights', name: 'Prohibition of torture & ill-treatment (including cruel, inhuman or degrading treatment)' },
  { id: 81, parentName: 'Civil & political rights', name: 'Domestic violence' },
  { id: 82, parentName: 'Civil & political rights', name: 'Extrajudicial, summary or arbitrary executions' },
  { id: 83, parentName: 'Civil & political rights', name: 'Conditions of detention' },
  { id: 84, parentName: 'Civil & political rights', name: 'Freedom of movement' },
  { id: 85, parentName: 'Civil & political rights', name: 'Freedom of association' },
  { id: 86, parentName: 'Civil & political rights', name: 'Private life & privacy' },
  { id: 87, parentName: 'Civil & political rights', name: 'Freedom of thought, conscience & religion' },
  { id: 88, parentName: 'Civil & political rights', name: 'Right to peaceful assembly' },
  { id: 89, parentName: 'Civil & political rights', name: 'Freedom of opinion and expression & access to information' },
  { id: 90, parentName: 'Civil & political rights', name: 'Liberty and security - general' },
  { id: 91, parentName: 'Civil & political rights', name: 'Arbitrary arrest & detention' },
  { id: 92, parentName: 'Civil & political rights', name: 'Enforced disappearances' },
  { id: 93, parentName: 'Civil & political rights', name: 'Right to be recognized as a person before the law' },
  { id: 94, parentName: 'Civil & political rights', name: 'Administration of justice & fair trial' },
  { id: 95, parentName: 'Economic, social & cultural rights', name: 'Economic, social & cultural rights - general measures of implementation' },
  { id: 96, parentName: 'Economic, social & cultural rights', name: 'Cultural rights' },
  { id: 97, parentName: 'Economic, social & cultural rights', name: 'Right to health' },
  { id: 98, parentName: 'Economic, social & cultural rights', name: 'Land & property rights' },
  { id: 99, parentName: 'Economic, social & cultural rights', name: 'Right to education' },
  { id: 100, parentName: 'Economic, social & cultural rights', name: 'Labour rights' },
  { id: 101, parentName: 'Economic, social & cultural rights', name: 'Right to an adequate standard of living' },
  { id: 102, parentName: 'Economic, social & cultural rights', name: 'Health awareness raising, access to information' },
  { id: 103, parentName: 'Economic, social & cultural rights', name: 'Access to health-care (general)' },
  { id: 104, parentName: 'Economic, social & cultural rights', name: 'Right to health - General' },
  { id: 105, parentName: 'Economic, social & cultural rights', name: 'Sexual & reproductive health and rights' },
  { id: 106, parentName: 'Economic, social & cultural rights', name: 'Basic/continuing education' },
  { id: 107, parentName: 'Economic, social & cultural rights', name: 'Secondary education' },
  { id: 108, parentName: 'Economic, social & cultural rights', name: 'Higher education' },
  { id: 109, parentName: 'Economic, social & cultural rights', name: 'Technical and vocational education' },
  { id: 110, parentName: 'Economic, social & cultural rights', name: 'Primary education' },
  { id: 111, parentName: 'Economic, social & cultural rights', name: 'Right to education' },
  { id: 112, parentName: 'Economic, social & cultural rights', name: 'Labour rights and right to work' },
  { id: 113, parentName: 'Economic, social & cultural rights', name: 'Right to just and favourable conditions of work' },
  { id: 114, parentName: 'Economic, social & cultural rights', name: 'Trade union rights' },
  { id: 115, parentName: 'Economic, social & cultural rights', name: 'Human rights & poverty' },
  { id: 116, parentName: 'Economic, social & cultural rights', name: 'Right to food' },
  { id: 117, parentName: 'Economic, social & cultural rights', name: 'Right to social security' },
  { id: 118, parentName: 'Economic, social & cultural rights', name: 'Safe drinking water & sanitation' },
  { id: 119, parentName: 'Economic, social & cultural rights', name: 'Right to an adequate standard of living - general' },
  { id: 120, parentName: 'Economic, social & cultural rights', name: 'Right to adequate housing' },
  { id: 121, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Human rights defenders' },
  { id: 122, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Migrants' },
  { id: 123, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Non-citizens' },
  { id: 124, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Internally displaced persons' },
  { id: 125, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Older persons' },
  { id: 126, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons living with HIV/AIDS' },
  { id: 127, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Women' },
  { id: 128, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons with disabilities' },
  { id: 129, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Children' },
  { id: 130, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Stateless persons' },
  { id: 131, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Members of minorities' },
  { id: 132, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Refugees & asylum seekers' },
  { id: 133, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons living in rural areas' },
  { id: 134, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Lesbian, gay, bisexual and transgender and intersex persons (LGBTI)' },
  { id: 135, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Indigenous peoples' },
  { id: 136, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons deprived of liberty: concept of places of deprivation of liberty' },
  { id: 137, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons deprived of liberty: definition of torture & ill-treatment' },
  { id: 138, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Violence against women' },
  { id: 139, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Girls' },
  { id: 140, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Advancement of women' },
  { id: 141, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Participation of women in political & public life ' },
  { id: 142, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Discrimination against women' },
  { id: 143, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons with disabilities: definition, general principles' },
  { id: 144, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons with disabilities: recreation, leisure and sport' },
  { id: 145, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons with disabilities: protection against exploitation, violence & abuse' },
  { id: 146, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons with disabilities: accessibility, mobility' },
  { id: 147, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons with disabilities: independence, inclusion' },
  { id: 148, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons with disabilities: protecting the integrity of the person' },
  { id: 149, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Persons with disabilities: protection and safety in situations of risk' },
  { id: 150, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Youth' },
  { id: 151, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Children: juvenile justice' },
  { id: 152, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Children: protection against exploitation' },
  { id: 153, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Children: definition; general principles; protection' },
  { id: 154, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Children: family environment & alternative care' },
  { id: 155, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Children in armed conflict' },
  { id: 156, parentName: 'Specific legal concepts that relates to persons or groups', name: 'Children in street situations' },
  { id: 157, parentName: 'S Sustainable Development Goal implementation', name: 'S07 SDG 7 - Energy' },
  { id: 158, parentName: 'S Sustainable Development Goal implementation', name: 'S04 SDG 4 - Education' },
  { id: 159, parentName: 'S Sustainable Development Goal implementation', name: 'S17 SDG 17 - Partnerships' },
  { id: 160, parentName: 'S Sustainable Development Goal implementation', name: 'S15 SDG 15 - Biodiversity, forests, desertification' },
  { id: 161, parentName: 'S Sustainable Development Goal implementation', name: 'S12 SDG 12 - Sustainable consumption and production' },
  { id: 162, parentName: 'S Sustainable Development Goal implementation', name: 'S10 SDG 10 - Inequality' },
  { id: 163, parentName: 'S Sustainable Development Goal implementation', name: 'S02 SDG 2 - Hunger and food security' },
  { id: 164, parentName: 'S Sustainable Development Goal implementation', name: 'S05 SDG 5 - Gender equality and women\'s empowerment' },
  { id: 165, parentName: 'S Sustainable Development Goal implementation', name: 'S09 SDG 9 - Infrastructure, industrialization' },
  { id: 166, parentName: 'S Sustainable Development Goal implementation', name: 'S11 SDG 11 - Cities' },
  { id: 167, parentName: 'S Sustainable Development Goal implementation', name: 'S08 SDG 8 - Economic growth, employment, decent work' },
  { id: 168, parentName: 'S Sustainable Development Goal implementation', name: 'S13 SDG 13 - Climate change' },
  { id: 169, parentName: 'S Sustainable Development Goal implementation', name: 'S06 SDG 6 - Water and sanitation' },
  { id: 170, parentName: 'S Sustainable Development Goal implementation', name: 'S03 SDG 3 - Health' },
  { id: 171, parentName: 'S Sustainable Development Goal implementation', name: 'S01 SDG 1 - Poverty' },
  { id: 172, parentName: 'S Sustainable Development Goal implementation', name: 'S14 SDG 14 - Oceans' },
  { id: 173, parentName: 'S Sustainable Development Goal implementation', name: 'S16 SDG 16 - Peace, justice and strong institutions' },
];

export const DOCUMENTS = [
  { name: 'Action plan on advancement of women' },
  { name: 'National action plan on health of the youth 2020-2022' },
  { name: 'National Action Plan on reproductive health and services for women (2020-2022).' },
  { name: 'National Plan on Education' },
  { name: 'National Plan on Racism' }
];

export const IMPLEMENTATION_STATUSES = [
  'Completed', 'In progress', 'Not started'
];

export const ACTIVITIES = [
  {
    id: 1,
    name: 'Elaboration of the legislative amendments',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 2,
    name: 'Training on effective investigation of torture',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 3,
    name: 'Training of prision officals on Seclusion and Restraint Regulations',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 4,
    name: 'Introduce an integral registration system and appropriate safeguards to administer electroshock therapy',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 5,
    name: 'Establish independent body to investigations into all allegations of ill-treatment and excessive use of force by law enforcement officials.',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 6,
    name: 'Draft of  bill for the the establishment of a national human rights institution in line with the Paris Principles',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 7,
    name: 'Women and girls who seek asylum to be given priority (refugee quota)',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 8,
    name: 'Gender mainstreaming of training package for airport, customs and and law enforcement personnel',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 9,
    name: 'Increase funding for projects support the implementation of Security Council resolution 1325',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 10,
    name: 'Holding session with the human rights committee in Parliament to propose changes',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 11,
    name: 'Establish a working group to improve data-collection on the national budget on the implementation of CRC',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 12,
    name: 'Development of a tracking system for resources used for children\'s rights',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 13,
    name: 'Prepare for Impact assesment of investment or cuts in the national budget impact girls or boys',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 14,
    name: 'Campagne de sensibilisation sur le racisme',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 15,
    name: 'Awareness raising campaigns at schools',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 16,
    name: 'Establish child care facilities at research/education institutions',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 17,
    name: 'Propose law to the parliement',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 18,
    name: 'Law Drafting Session',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 19,
    name: 'Sample Activity',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 20,
    name: 'Undertake a mapping exercise on who are the key stakeholder that should be consulted',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 21,
    name: 'Prepare a draft bill',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 22,
    name: 'Organizing a workshop  with experts to review the Anti-Discrimination Act',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 23,
    name: 'Hiring of a consultant to review Anti-Discrimination Act',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 24,
    name: 'undertake a study reviewing how the media is portraying girls and women in advertisement',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 25,
    name: 'Adopt a bill in consultation with Sami community to ensure that their lands are respected and that any commercial entity is informed about the law',
    description: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,',
    implementationStatus: IMPLEMENTATION_STATUSES[Math.floor(IMPLEMENTATION_STATUSES.length * Math.random())],
    leadInstitution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
    projectIds: [2, 5],
    recommendationIds: [3, 5],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
];

export const PROJECTS = [
  {
    id: 1,
    name: 'Equality & non-discrimination',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'blue', class: "fa-light fa-sitemap" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 2,
    name: 'Members of minorities',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'green', class: "fa-regular fa-chart-network" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 3,
    name: 'CERD',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'red', class: "fa-regular fa-flag" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 4,
    name: 'Eripteum sit amet',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'yellow', class: "fa-regular fa-book" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 5,
    name: 'Sit amet eripteum',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'blue', class: "fa-light fa-sitemap" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 6,
    name: 'Eripteum eripteum 1',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'green', class: "fa-regular fa-chart-network" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 7,
    name: 'Eripteum eripteum 2',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'red', class: "fa-regular fa-flag" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 8,
    name: 'Eripteum eripteum 3',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'yellow', class: "fa-regular fa-book" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 9,
    name: 'Eripteum eripteum 4',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'blue', class: "fa-light fa-sitemap" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 10,
    name: 'Eripteum eripteum 5',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'green', class: "fa-regular fa-chart-network" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 11,
    name: 'Eripteum eripteum 6',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'red', class: "fa-regular fa-flag" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 11,
    name: 'Eripteum eripteum 6',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'red', class: "fa-regular fa-flag" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 12,
    name: 'Eripteum eripteum 7',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'red', class: "fa-regular fa-flag" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 13,
    name: 'Eripteum eripteum 8',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'red', class: "fa-regular fa-flag" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
  {
    id: 14,
    name: 'Eripteum eripteum 9',
    description: "Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards.",
    progress: Math.floor(Math.random() * 100),
    recommendations: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    activities: [
      { id: 2, implemented: true },
      { id: 3, implemented: true },
      { id: 4, implemented: true },
      { id: 5, implemented: true },
      { id: 6, implemented: false },
      { id: 7, implemented: false },
      { id: 8, implemented: false },
      { id: 9, implemented: false },
      { id: 10, implemented: false },
      { id: 11, implemented: false },
    ],
    icon: { theme: 'red', class: "fa-regular fa-flag" },
    actionPlans: ["Gender Equality Action Plan", "NATIONAL POVERTY STRATEGY"],
    institutions: [INSTITUTIONS[Math.floor(Math.random() * INSTITUTIONS.length)].name],
    attachments: [{ name: 'LOREM-IPSUM-DOLOR.PDF', url: 'https://www.google.com' }]
  },
];

export const EMPTY_PROJECT = {
  id: 'empty',
  name: 'Members of minorities',
  description: "",
  progress: 0,
  recommendations: [],
  activities: [],
  icon: { color: '#FE4D97', bgColor: '#FFD8DA', class: "lar la-flag" },
  actionPlans: [],
  institutions: ['Ministry of Justice'],
  attachments: []
};

export const RECOMMENDATIONS = [
  {
    id: 1,
    name: "41. The Committee calls for the realization of substantive gender equality, in accordance with the provisions of the Convention, throughout the process of implementation of the 2030 Agenda for Sustainable Development.",
    projectIds: [1, 3, 5]
  },
  {
    id: 2,
    name: "42. The Committee requests the State party to ensure the timely dissemination of the present concluding observations, in the official language of the State party, to the relevant state institutions at all levels (national, regional, local), in particular to the Government, the ministries, the parliament and the judiciary, to enable their full implementation. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 3,
    name: "43. The Committee notes that the adherence of the State party to the nine major international human rights instruments would enhance the enjoyment by women of their human rights and fundamental freedoms in all aspects of life. The Committee therefore encourages the State party to consider ratifying the International Convention for the Protection of All Persons from Enforced Disappearance and the International Convention on the Protection of the Rights of All Migrant Workers and Members of Their Families, to which it is not yet a party.",
    projectIds: [1, 3, 5]
  },
  {
    id: 4,
    name: "44. The Committee requests the State party to provide, within two years, written information on the steps taken to implement the recommendations contained in paragraphs 11 (a), (b) and (c) and 27 (a) and (c) above.",
    projectIds: [1, 3, 5]
  },
  {
    id: 5,
    name: "45. The Committee invites the State party to submit its tenth periodic report in March 2020.",
    projectIds: [1, 3, 5]
  },
  {
    id: 6,
    name: "Recalling its general recommendation No. 17 (1993) on the establishment of national institutions to facilitate the implementation of the Convention, the Committee recommends that the State party also consider establishing an independent national human rights institution for the protection and promotion of human rights in conformity with the Paris Principles, and provided with adequate financial and human resources in order to efficiently fight against discrimination.",
    projectIds: [1, 3, 5]
  },
  {
    id: 7,
    name: "The Committee recommends that the State party develop a clear strategy to ensure scrutiny of the way police and prosecutors deal with hate crimes and that it replicate measures such as hate crime units and special investigators in all parts of the country. The State party should extend to all parts of the country the training given to the police, prosecutors and judges to effectively investigate, prosecute and punish hate crimes, in order to close the gap between reported incidents and convictions. The Committee reiterates its request that the State party introduce a common and clear definition of hate crime so that it is possible to track all such reported crimes through the justice system. The State party should also follow up on the report of its special investigator on further measures to combat xenophobia and similar forms of intolerance.",
    projectIds: [1, 3, 5]
  },
  {
    id: 8,
    name: "Recalling its general recommendations No. 7 (1985) on legislation to eradicate racial discrimination and No. 30 (2004) on discrimination against non - citizens, the Committee recommends that the State party effectively investigate, prosecute and punish all hate crimes and take effective measures to combat hate speech in the media and on the Internet, including by prosecuting the perpetrators, where appropriate, regardless of their official status. The Committee urges the State party to take the necessary measures to promote tolerance, intercultural dialogue and respect for diversity, aiming those measures at journalists, inter alios.",
    projectIds: [1, 3, 5]
  },
  {
    id: 9,
    name: "Drawing attention to general recommendation No. 15 (1993) on article 4 of the Convention, the Committee reiterates its previous recommendation that the State party amend its legislation to declare illegal and prohibit organizations promoting and inciting racial hatred, in line with article 4 (b) of the Convention.",
    projectIds: [1, 3, 5]
  },
  {
    id: 10,
    name: "The Committee recommends that the State party study the causes of the 2013 riots with a view to assessing the effectiveness of its strategies against prevailing de facto segregation in Sweden along ethnic and socioeconomic lines, and the need for those strategies to be adjusted. The Committee also recommends that the State party take further legal and policy measures to address the problem of social exclusion and segregation along ethnic lines.",
    projectIds: [1, 3, 5]
  },
  {
    id: 11,
    name: "The Committee recommends that the State party evaluate the results of the Comprehensive National Strategy for Integration with a view to addressing prevailing discrimination against persons of foreign origin throughout the country. The State party should in particular take further effective measures to increase access to education and employment by persons of foreign origin .",
    projectIds: [1, 3, 5]
  },
  {
    id: 12,
    name: "14. The Committee recommends that the State party ensure that the perspective of gender and disability permeate s its legislation and policies, surveys and plans , its implementation, evaluation and monitoring activities and its services . It also r ecommends that the State party adopt effective and specific measures to prevent intersectional forms of discrimination against wom en and girls with disabilities.",
    projectIds: [1, 3, 5]
  },
  {
    id: 13,
    name: "16. The Committee recommends that the State party develop research as well as a collection of data and statistics on violence against children with disabilities. It also recommends that the State party reinforc e its strategy and initiatives for the sensitization and training of parent s and staff working with children as well as for awareness-raising among the general public .",
    projectIds: [1, 3, 5]
  },
  {
    id: 14,
    name: "18. The Committee recommends that the State party increase the resources available for school health services to ensure that children have access to and re ceive appropriate psychosocial and mental - health support and psychiatric health care in a timely manner.",
    projectIds: [1, 3, 5]
  },
  {
    id: 15,
    name: "20. The Committee recommends that the State party ensure existing safeguards and adopt additional ones to protect the right of children with disabilities to be consulted in all matters concerning them.",
    projectIds: [1, 3, 5]
  },
  {
    id: 16,
    name: "22. The Committee encourages the State party to create a strategy that increases public knowledge about different disabilities and to reinforce not only a positive but also an informative image of men and women with disabilities as dignified , independent and capable individuals who are holders of all the human rights recognized in the Convention , with the aim to remove sociocultural discrimination barriers in public life . The Committee further recommends that specific programmes be established, in consultation with disabled persons’ organizations, to raise awareness among public sector employees.",
    projectIds: [1, 3, 5]
  },
  {
    id: 17,
    name: "24. The Committee recommends that the State party launch periodic, regular and continuous national campaigns and other training courses targeted to public officials and private actors to enable them to be come acquainted with the general and specific contents of the Convention that have recently been incorporated into human rights law.",
    projectIds: [1, 3, 5]
  },
  {
    id: 18,
    name: "26. The Committee recommends that the State party ensure that municipalities and local authorities are sensitized about the accessibility principle , with a view to align ing relevant local and regional laws, such as building and planning codes, in accordance with article 9 of the Convention; that they have the necessary funding and guidance to monitor , evaluate and secure full accessibility to buildings ; and that the reasonable accommodation needs of persons with disabilities are integrated in municipal planning as appropriate . The Committee fu rther recommends that accessibility requirements be systematically included in all public procurement agreements .",
    projectIds: [1, 3, 5]
  },
  {
    id: 19,
    name: "28. The Committee encourages the State party to supplement the regulatory framework concerning the public sector’s responsibility to present its information and communications in accessible formats.",
    projectIds: [1, 3, 5]
  },
  {
    id: 20,
    name: "30. The Committee urges the State party to adopt all necessary measures to prevent, identify and address situations of risk of suicide in persons with disabilities, including boys and girls.",
    projectIds: [1, 3, 5]
  },
  {
    id: 21,
    name: "32. The Committee recommends that the State party undertake to ensure that disaster risk reduction is fully accessible and disability inclusive , and take measures to ensure its preparedness to provide persons with disabilities with the necessary support in the event of a disaster.",
    projectIds: [1, 3, 5]
  },
  {
    id: 22,
    name: "In the light of its general comment No. 12 (2009) on the right of the child to be heard, the Committee recommends that the State party take measures to strengthen that right in accordance with article 12 of the Convention and to ensure the effective implementation of legislation recognizing the right of the child to be heard in relevant legal proceedings, including by establishing systems and/or procedures for social workers and courts to comply with the principle. The Committee also calls upon the State party to take prompt legal measures to amend chapter 1, section 11, of the Aliens Act, abolish the exception of inappropriateness, and ensure that a child is heard whenever a decision affecting him or her is made. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 23,
    name: "The Committee encourages the State party to increase the allocation of human, technical and financial resources to helplines to provide a nationwide 24-hour service.",
    projectIds: [1, 3, 5]
  },
  {
    id: 24,
    name: "The Committee recommends that the State party take all the necessary measures to enable children with parents in prison to maintain personal relations and direct contact with them, and systematically apply the principle of closeness. The Committee also encourages the State party to continue to increase child-friendly visiting facilities in prisons.",
    projectIds: [1, 3, 5]
  },
  {
    id: 25,
    name: "The Committee recommends that the State party fully regulate practices relating to the removal of children from their families and ensure that removal is always subject to thorough investigation, is in accordance with the best interests of the child and is used as a measure of last resort.",
    projectIds: [1, 3, 5]
  },
  {
    id: 26,
    name: "9. The Committee reiterates its recommendation (see CCPR/C/SWE/CO/6, para. 4) that the State party establish, without undue delay, an independent national human rights institution invested with a broad human rights mandate and provide it with adequate financial and human resources, in accordance with the principles relating to the status of national institutions for the promotion and protection of human rights (the Paris Principles).",
    projectIds: [1, 3, 5]
  },
  {
    id: 27,
    name: "11. The State party should consider, in the framework of the current review of its anti-discrimination legislation, expanding the scope of protection against discrimination under its domestic law by, inter alia, introducing a prohibition of discrimination in all spheres and sectors in full compliance with the anti-discrimination provisions of the Covenant. The State party should also improve the accessibility of effective remedies against any form of discrimination, including by considering expanding the mandate of the Equality Ombudsman to all forms of discrimination and expanding the legal aid criteria to enable victims of discrimination to pursue their cases in court where the interests of justice so require.",
    projectIds: [1, 3, 5]
  },
  {
    id: 28,
    name: "13. The State party should strengthen the measures taken to improve equal access of persons with disabilities to employment, education, health care, justice and governmental services, without any discrimination.",
    projectIds: [1, 3, 5]
  },
  {
    id: 29,
    name: "15. The State party should take all measures necessary to ensure equal access by Roma to various opportunities and services, including to education, employment, housing and health care, without discrimination. It should also ensure that all individuals within its jurisdiction, including vulnerable Roma citizens of other European Union countries, enjoy equal rights without discrimination and identify ways to facilitate their access to support assistance services, including social benefits, taking into account both their de jure and de facto situation. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 30,
    name: "17. The State party should redouble its efforts, both through law enforcement activities and awareness-raising, to combat hate speech, including on the Internet, racist and xenophobic violence against and negative stereotyping and portrayal of ethnic or religious minorities, in accordance with articles 19 and 20 of the Covenant and the Committee’s general comment No. 34 (2011) on freedoms of opinion and expression. It should, inter alia: (a) institute new awareness-raising campaigns aimed at promoting respect for human rights and tolerance for diversity and targeted at revisiting and eradicating stereotypes towards different ethnic or religious minorities; and (b) effectively implement the legal and policy frameworks to counter all manifestations of racism, hatred and xenophobia, including by thoroughly investigating such cases, prosecuting suspected perpetrators where appropriate and, if they are convicted, punishing them and providing victims with adequate remedies.",
    projectIds: [1, 3, 5]
  },
  {
    id: 31,
    name: "19. The State party should step up its efforts with a view to promoting women’s equal access to full-time employment and to eliminating the gender wage gap by tackling vertical and horizontal segregation in employment and addressing differences in pay between men and women for the same work.",
    projectIds: [1, 3, 5]
  },
  {
    id: 32,
    name: "23. The State party should pursue its plans to review comprehensively the counter-terrorism legislation and ensure that any existing and future counter-terrorism legislation and practices are in full conformity with the State party’s obligations under the Covenant, including with the principle of non-discrimination and the right to liberty and security. It should, inter alia, ensure that the principles of necessity and proportionality are strictly observed in the application of arrest powers under the Terrorism Act, and take effective measures to prevent different treatment by law enforcement officials of criminal suspects by reason of their religion and/or ethnicity, including by providing appropriate training on cultural awareness and the inadmissibility of racial profiling. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 33,
    name: "25. The State party should:",
    projectIds: [1, 3, 5]
  },
  {
    id: 34,
    name: "(a) Undertake regular reviews of measures employed in law enforcement operations, including types of firearms and ammunition used, with a view to ensuring the application of least harmful means in all circumstances;",
    projectIds: [1, 3, 5]
  },
  {
    id: 35,
    name: "(b) Ensure that law enforcement officers receive appropriate professional training, including on how to avoid excessive use of force and how to handle persons with mental disabilities; ",
    projectIds: [1, 3, 5]
  },
  {
    id: 36,
    name: "(c) Review its position vis-à-vis the operation of the Department of Special Investigations under the administrative framework of the Swedish Police Authority to ensure that the body entrusted to investigate complaints against the police is truly independent of the police and is perceived as such;",
    projectIds: [1, 3, 5]
  },
  {
    id: 37,
    name: "(d) Ensure that reported cases of excessive use of force are independently and effectively investigated; that alleged perpetrators are prosecuted and, if convicted, punished with appropriate sanctions; and that victims or their families are provided with redress, including adequate compensation.",
    projectIds: [1, 3, 5]
  },
  {
    id: 38,
    name: "27. The State party should take expeditious measures to include in its Criminal Code a definition of torture that is fully in line with article 7 of the Covenant and internationally established norms, including with respect to an appropriate statute of limitations for the grave crime of torture. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 39,
    name: "29. The State party should bring its legislation and practices into compliance with article 9 of the Covenant, taking into account the Committee’s general comment No. 35 (2014) on liberty and security of persons. The State party should, inter alia:",
    projectIds: [1, 3, 5]
  },
  {
    id: 40,
    name: "(a) Establish a statutory time limit on the duration of pretrial detention and ensure that pretrial detention constitutes an exceptional measure and that, in practice, priority is given to alternative measures to detention;",
    projectIds: [1, 3, 5]
  },
  {
    id: 41,
    name: "(b) Ensure that all persons are afforded, in practice, the right to a counsel from the very outset of their deprivation of liberty;",
    projectIds: [1, 3, 5]
  },
  {
    id: 42,
    name: "(c) Ensure that all restrictions on contacts for pretrial detainees are time-bound and are justified as necessary and proportionate in the light of all the relevant circumstances; that the scope and the extent of their application is subject to constant review; and that appropriate measures to mitigate isolation are provided, in particular for young detainees.41. The Committee calls for the realization of substantive gender equality, in accordance with the provisions of the Convention, throughout the process of implementation of the 2030 Agenda for Sustainable Development.",
    projectIds: [1, 3, 5]
  },
  {
    id: 43,
    name: "41. The Committee calls for the realization of substantive gender equality, in accordance with the provisions of the Convention, throughout the process of implementation of the 2030 Agenda for Sustainable Development.",
    projectIds: [1, 3, 5]
  },
  {
    id: 44,
    name: "42. The Committee requests the State party to ensure the timely dissemination of the present concluding observations, in the official language of the State party, to the relevant state institutions at all levels (national, regional, local), in particular to the Government, the ministries, the parliament and the judiciary, to enable their full implementation. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 45,
    name: "43. The Committee notes that the adherence of the State party to the nine major international human rights instruments would enhance the enjoyment by women of their human rights and fundamental freedoms in all aspects of life. The Committee therefore encourages the State party to consider ratifying the International Convention for the Protection of All Persons from Enforced Disappearance and the International Convention on the Protection of the Rights of All Migrant Workers and Members of Their Families, to which it is not yet a party.",
    projectIds: [1, 3, 5]
  },
  {
    id: 46,
    name: "44. The Committee requests the State party to provide, within two years, written information on the steps taken to implement the recommendations contained in paragraphs 11 (a), (b) and (c) and 27 (a) and (c) above.",
    projectIds: [1, 3, 5]
  },
  {
    id: 47,
    name: "45. The Committee invites the State party to submit its tenth periodic report in March 2020.",
    projectIds: [1, 3, 5]
  },
  {
    id: 48,
    name: "Recalling its general recommendation No. 17 (1993) on the establishment of national institutions to facilitate the implementation of the Convention, the Committee recommends that the State party also consider establishing an independent national human rights institution for the protection and promotion of human rights in conformity with the Paris Principles, and provided with adequate financial and human resources in order to efficiently fight against discrimination.",
    projectIds: [1, 3, 5]
  },
  {
    id: 49,
    name: "The Committee recommends that the State party develop a clear strategy to ensure scrutiny of the way police and prosecutors deal with hate crimes and that it replicate measures such as hate crime units and special investigators in all parts of the country. The State party should extend to all parts of the country the training given to the police, prosecutors and judges to effectively investigate, prosecute and punish hate crimes, in order to close the gap between reported incidents and convictions. The Committee reiterates its request that the State party introduce a common and clear definition of hate crime so that it is possible to track all such reported crimes through the justice system. The State party should also follow up on the report of its special investigator on further measures to combat xenophobia and similar forms of intolerance.",
    projectIds: [1, 3, 5]
  },
  {
    id: 50,
    name: "Recalling its general recommendations No. 7 (1985) on legislation to eradicate racial discrimination and No. 30 (2004) on discrimination against non - citizens, the Committee recommends that the State party effectively investigate, prosecute and punish all hate crimes and take effective measures to combat hate speech in the media and on the Internet, including by prosecuting the perpetrators, where appropriate, regardless of their official status. The Committee urges the State party to take the necessary measures to promote tolerance, intercultural dialogue and respect for diversity, aiming those measures at journalists, inter alios .",
    projectIds: [1, 3, 5]
  },
  {
    id: 51,
    name: "Drawing attention to general recommendation No. 15 (1993) on article 4 of the Convention, the Committee reiterates its previous recommendation that the State party amend its legislation to declare illegal and prohibit organizations promoting and inciting racial hatred, in line with article 4 (b) of the Convention.",
    projectIds: [1, 3, 5]
  },
  {
    id: 52,
    name: "The Committee recommends that the State party study the causes of the 2013 riots with a view to assessing the effectiveness of its strategies against prevailing de facto segregation in Sweden along ethnic and socioeconomic lines, and the need for those strategies to be adjusted. The Committee also recommends that the State party take further legal and policy measures to address the problem of social exclusion and segregation along ethnic lines.",
    projectIds: [1, 3, 5]
  },
  {
    id: 53,
    name: "The Committee recommends that the State party evaluate the results of the Comprehensive National Strategy for Integration with a view to addressing prevailing discrimination against persons of foreign origin throughout the country. The State party should in particular take further effective measures to increase access to education and employment by persons of foreign origin .",
    projectIds: [1, 3, 5]
  },
  {
    id: 54,
    name: "14. The Committee recommends that the State party ensure that the perspective of gender and disability permeate s its legislation and policies, surveys and plans , its implementation, evaluation and monitoring activities and its services . It also r ecommends that the State party adopt effective and specific measures to prevent intersectional forms of discrimination against wom en and girls with disabilities.",
    projectIds: [1, 3, 5]
  },
  {
    id: 55,
    name: "16. The Committee recommends that the State party develop research as well as a collection of data and statistics on violence against children with disabilities. It also recommends that the State party reinforc e its strategy and initiatives for the sensitization and training of parent s and staff working with children as well as for awareness-raising among the general public .",
    projectIds: [1, 3, 5]
  },
  {
    id: 56,
    name: "18. The Committee recommends that the State party increase the resources available for school health services to ensure that children have access to and re ceive appropriate psychosocial and mental - health support and psychiatric health care in a timely manner.",
    projectIds: [1, 3, 5]
  },
  {
    id: 57,
    name: "20. The Committee recommends that the State party ensure existing safeguards and adopt additional ones to protect the right of children with disabilities to be consulted in all matters concerning them.",
    projectIds: [1, 3, 5]
  },
  {
    id: 58,
    name: "22. The Committee encourages the State party to create a strategy that increases public knowledge about different disabilities and to reinforce not only a positive but also an informative image of men and women with disabilities as dignified , independent and capable individuals who are holders of all the human rights recognized in the Convention , with the aim to remove sociocultural discrimination barriers in public life . The Committee further recommends that specific programmes be established, in consultation with disabled persons’ organizations, to raise awareness among public sector employees.",
    projectIds: [1, 3, 5]
  },
  {
    id: 59,
    name: "24. The Committee recommends that the State party launch periodic, regular and continuous national campaigns and other training courses targeted to public officials and private actors to enable them to be come acquainted with the general and specific contents of the Convention that have recently been incorporated into human rights law.",
    projectIds: [1, 3, 5]
  },
  {
    id: 60,
    name: "26. The Committee recommends that the State party ensure that municipalities and local authorities are sensitized about the accessibility principle , with a view to align ing relevant local and regional laws, such as building and planning codes, in accordance with article 9 of the Convention; that they have the necessary funding and guidance to monitor , evaluate and secure full accessibility to buildings ; and that the reasonable accommodation needs of persons with disabilities are integrated in municipal planning as appropriate . The Committee fu rther recommends that accessibility requirements be systematically included in all public procurement agreements .",
    projectIds: [1, 3, 5]
  },
  {
    id: 61,
    name: "28. The Committee encourages the State party to supplement the regulatory framework concerning the public sector’s responsibility to present its information and communications in accessible formats.",
    projectIds: [1, 3, 5]
  },
  {
    id: 62,
    name: "30. The Committee urges the State party to adopt all necessary measures to prevent, identify and address situations of risk of suicide in persons with disabilities, including boys and girls.",
    projectIds: [1, 3, 5]
  },
  {
    id: 63,
    name: "32. The Committee recommends that the State party undertake to ensure that disaster risk reduction is fully accessible and disability inclusive , and take measures to ensure its preparedness to provide persons with disabilities with the necessary support in the event of a disaster.",
    projectIds: [1, 3, 5]
  },
  {
    id: 64,
    name: "In the light of its general comment No. 12 (2009) on the right of the child to be heard, the Committee recommends that the State party take measures to strengthen that right in accordance with article 12 of the Convention and to ensure the effective implementation of legislation recognizing the right of the child to be heard in relevant legal proceedings, including by establishing systems and/or procedures for social workers and courts to comply with the principle. The Committee also calls upon the State party to take prompt legal measures to amend chapter 1, section 11, of the Aliens Act, abolish the exception of inappropriateness, and ensure that a child is heard whenever a decision affecting him or her is made. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 65,
    name: "The Committee encourages the State party to increase the allocation of human, technical and financial resources to helplines to provide a nationwide 24-hour service.",
    projectIds: [1, 3, 5]
  },
  {
    id: 66,
    name: "The Committee recommends that the State party take all the necessary measures to enable children with parents in prison to maintain personal relations and direct contact with them, and systematically apply the principle of closeness. The Committee also encourages the State party to continue to increase child-friendly visiting facilities in prisons.",
    projectIds: [1, 3, 5]
  },
  {
    id: 67,
    name: "The Committee recommends that the State party fully regulate practices relating to the removal of children from their families and ensure that removal is always subject to thorough investigation, is in accordance with the best interests of the child and is used as a measure of last resort.",
    projectIds: [1, 3, 5]
  },
  {
    id: 68,
    name: "9. The Committee reiterates its recommendation (see CCPR/C/SWE/CO/6, para. 4) that the State party establish, without undue delay, an independent national human rights institution invested with a broad human rights mandate and provide it with adequate financial and human resources, in accordance with the principles relating to the status of national institutions for the promotion and protection of human rights (the Paris Principles).",
    projectIds: [1, 3, 5]
  },
  {
    id: 69,
    name: "11. The State party should consider, in the framework of the current review of its anti-discrimination legislation, expanding the scope of protection against discrimination under its domestic law by, inter alia, introducing a prohibition of discrimination in all spheres and sectors in full compliance with the anti-discrimination provisions of the Covenant. The State party should also improve the accessibility of effective remedies against any form of discrimination, including by considering expanding the mandate of the Equality Ombudsman to all forms of discrimination and expanding the legal aid criteria to enable victims of discrimination to pursue their cases in court where the interests of justice so require.",
    projectIds: [1, 3, 5]
  },
  {
    id: 70,
    name: "13. The State party should strengthen the measures taken to improve equal access of persons with disabilities to employment, education, health care, justice and governmental services, without any discrimination.",
    projectIds: [1, 3, 5]
  },
  {
    id: 71,
    name: "15. The State party should take all measures necessary to ensure equal access by Roma to various opportunities and services, including to education, employment, housing and health care, without discrimination. It should also ensure that all individuals within its jurisdiction, including vulnerable Roma citizens of other European Union countries, enjoy equal rights without discrimination and identify ways to facilitate their access to support assistance services, including social benefits, taking into account both their de jure and de facto situation. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 72,
    name: "17. The State party should redouble its efforts, both through law enforcement activities and awareness-raising, to combat hate speech, including on the Internet, racist and xenophobic violence against and negative stereotyping and portrayal of ethnic or religious minorities, in accordance with articles 19 and 20 of the Covenant and the Committee’s general comment No. 34 (2011) on freedoms of opinion and expression. It should, inter alia: (a) institute new awareness-raising campaigns aimed at promoting respect for human rights and tolerance for diversity and targeted at revisiting and eradicating stereotypes towards different ethnic or religious minorities; and (b) effectively implement the legal and policy frameworks to counter all manifestations of racism, hatred and xenophobia, including by thoroughly investigating such cases, prosecuting suspected perpetrators where appropriate and, if they are convicted, punishing them and providing victims with adequate remedies.",
    projectIds: [1, 3, 5]
  },
  {
    id: 73,
    name: "19. The State party should step up its efforts with a view to promoting women’s equal access to full-time employment and to eliminating the gender wage gap by tackling vertical and horizontal segregation in employment and addressing differences in pay between men and women for the same work.",
    projectIds: [1, 3, 5]
  },
  {
    id: 74,
    name: "23. The State party should pursue its plans to review comprehensively the counter-terrorism legislation and ensure that any existing and future counter-terrorism legislation and practices are in full conformity with the State party’s obligations under the Covenant, including with the principle of non-discrimination and the right to liberty and security. It should, inter alia, ensure that the principles of necessity and proportionality are strictly observed in the application of arrest powers under the Terrorism Act, and take effective measures to prevent different treatment by law enforcement officials of criminal suspects by reason of their religion and/or ethnicity, including by providing appropriate training on cultural awareness and the inadmissibility of racial profiling. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 75,
    name: "25. The State party should:",
    projectIds: [1, 3, 5]
  },
  {
    id: 76,
    name: "(a) Undertake regular reviews of measures employed in law enforcement operations, including types of firearms and ammunition used, with a view to ensuring the application of least harmful means in all circumstances;",
    projectIds: [1, 3, 5]
  },
  {
    id: 77,
    name: "(b) Ensure that law enforcement officers receive appropriate professional training, including on how to avoid excessive use of force and how to handle persons with mental disabilities; ",
    projectIds: [1, 3, 5]
  },
  {
    id: 78,
    name: "(c) Review its position vis-à-vis the operation of the Department of Special Investigations under the administrative framework of the Swedish Police Authority to ensure that the body entrusted to investigate complaints against the police is truly independent of the police and is perceived as such;",
    projectIds: [1, 3, 5]
  },
  {
    id: 79,
    name: "(d) Ensure that reported cases of excessive use of force are independently and effectively investigated; that alleged perpetrators are prosecuted and, if convicted, punished with appropriate sanctions; and that victims or their families are provided with redress, including adequate compensation.",
    projectIds: [1, 3, 5]
  },
  {
    id: 80,
    name: "27. The State party should take expeditious measures to include in its Criminal Code a definition of torture that is fully in line with article 7 of the Covenant and internationally established norms, including with respect to an appropriate statute of limitations for the grave crime of torture. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 81,
    name: "29. The State party should bring its legislation and practices into compliance with article 9 of the Covenant, taking into account the Committee’s general comment No. 35 (2014) on liberty and security of persons. The State party should, inter alia:",
    projectIds: [1, 3, 5]
  },
  {
    id: 82,
    name: "(a) Establish a statutory time limit on the duration of pretrial detention and ensure that pretrial detention constitutes an exceptional measure and that, in practice, priority is given to alternative measures to detention;",
    projectIds: [1, 3, 5]
  },
  {
    id: 83,
    name: "(b) Ensure that all persons are afforded, in practice, the right to a counsel from the very outset of their deprivation of liberty;",
    projectIds: [1, 3, 5]
  },
  {
    id: 84,
    name: "(c) Ensure that all restrictions on contacts for pretrial detainees are time-bound and are justified as necessary and proportionate in the light of all the relevant circumstances; that the scope and the extent of their application is subject to constant review; and that appropriate measures to mitigate isolation are provided, in particular for young detainees.{",
    projectIds: [1, 3, 5]
  },
  {
    id: 85,
    name: "43. The Committee notes that the adherence of the State party to the nine major international human rights instruments would enhance the enjoyment by women of their human rights and fundamental freedoms in all aspects of life. The Committee therefore encourages the State party to consider ratifying the International Convention for the Protection of All Persons from Enforced Disappearance and the International Convention on the Protection of the Rights of All Migrant Workers and Members of Their Families, to which it is not yet a party.",
    projectIds: [1, 3, 5]
  },
  {
    id: 86,
    name: "44. The Committee requests the State party to provide, within two years, written information on the steps taken to implement the recommendations contained in paragraphs 11 (a), (b) and (c) and 27 (a) and (c) above.",
    projectIds: [1, 3, 5]
  },
  {
    id: 87,
    name: "45. The Committee invites the State party to submit its tenth periodic report in March 2020.",
    projectIds: [1, 3, 5]
  },
  {
    id: 88,
    name: "Recalling its general recommendation No. 17 (1993) on the establishment of national institutions to facilitate the implementation of the Convention, the Committee recommends that the State party also consider establishing an independent national human rights institution for the protection and promotion of human rights in conformity with the Paris Principles, and provided with adequate financial and human resources in order to efficiently fight against discrimination.",
    projectIds: [1, 3, 5]
  },
  {
    id: 89,
    name: "The Committee recommends that the State party develop a clear strategy to ensure scrutiny of the way police and prosecutors deal with hate crimes and that it replicate measures such as hate crime units and special investigators in all parts of the country. The State party should extend to all parts of the country the training given to the police, prosecutors and judges to effectively investigate, prosecute and punish hate crimes, in order to close the gap between reported incidents and convictions. The Committee reiterates its request that the State party introduce a common and clear definition of hate crime so that it is possible to track all such reported crimes through the justice system. The State party should also follow up on the report of its special investigator on further measures to combat xenophobia and similar forms of intolerance.",
    projectIds: [1, 3, 5]
  },
  {
    id: 90,
    name: "Recalling its general recommendations No. 7 (1985) on legislation to eradicate racial discrimination and No. 30 (2004) on discrimination against non - citizens, the Committee recommends that the State party effectively investigate, prosecute and punish all hate crimes and take effective measures to combat hate speech in the media and on the Internet, including by prosecuting the perpetrators, where appropriate, regardless of their official status. The Committee urges the State party to take the necessary measures to promote tolerance, intercultural dialogue and respect for diversity, aiming those measures at journalists, inter alios .",
    projectIds: [1, 3, 5]
  },
  {
    id: 91,
    name: "Drawing attention to general recommendation No. 15 (1993) on article 4 of the Convention, the Committee reiterates its previous recommendation that the State party amend its legislation to declare illegal and prohibit organizations promoting and inciting racial hatred, in line with article 4 (b) of the Convention.",
    projectIds: [1, 3, 5]
  },
  {
    id: 92,
    name: "The Committee recommends that the State party study the causes of the 2013 riots with a view to assessing the effectiveness of its strategies against prevailing de facto segregation in Sweden along ethnic and socioeconomic lines, and the need for those strategies to be adjusted. The Committee also recommends that the State party take further legal and policy measures to address the problem of social exclusion and segregation along ethnic lines.",
    projectIds: [1, 3, 5]
  },
  {
    id: 93,
    name: "The Committee recommends that the State party evaluate the results of the Comprehensive National Strategy for Integration with a view to addressing prevailing discrimination against persons of foreign origin throughout the country. The State party should in particular take further effective measures to increase access to education and employment by persons of foreign origin .",
    projectIds: [1, 3, 5]
  },
  {
    id: 94,
    name: "14. The Committee recommends that the State party ensure that the perspective of gender and disability permeate s its legislation and policies, surveys and plans , its implementation, evaluation and monitoring activities and its services . It also r ecommends that the State party adopt effective and specific measures to prevent intersectional forms of discrimination against wom en and girls with disabilities.",
    projectIds: [1, 3, 5]
  },
  {
    id: 95,
    name: "16. The Committee recommends that the State party develop research as well as a collection of data and statistics on violence against children with disabilities. It also recommends that the State party reinforc e its strategy and initiatives for the sensitization and training of parent s and staff working with children as well as for awareness-raising among the general public .",
    projectIds: [1, 3, 5]
  },
  {
    id: 96,
    name: "18. The Committee recommends that the State party increase the resources available for school health services to ensure that children have access to and re ceive appropriate psychosocial and mental - health support and psychiatric health care in a timely manner.",
    projectIds: [1, 3, 5]
  },
  {
    id: 97,
    name: "20. The Committee recommends that the State party ensure existing safeguards and adopt additional ones to protect the right of children with disabilities to be consulted in all matters concerning them.",
    projectIds: [1, 3, 5]
  },
  {
    id: 98,
    name: "22. The Committee encourages the State party to create a strategy that increases public knowledge about different disabilities and to reinforce not only a positive but also an informative image of men and women with disabilities as dignified , independent and capable individuals who are holders of all the human rights recognized in the Convention , with the aim to remove sociocultural discrimination barriers in public life . The Committee further recommends that specific programmes be established, in consultation with disabled persons’ organizations, to raise awareness among public sector employees.",
    projectIds: [1, 3, 5]
  },
  {
    id: 99,
    name: "24. The Committee recommends that the State party launch periodic, regular and continuous national campaigns and other training courses targeted to public officials and private actors to enable them to be come acquainted with the general and specific contents of the Convention that have recently been incorporated into human rights law.",
    projectIds: [1, 3, 5]
  },
  {
    id: 100,
    name: "26. The Committee recommends that the State party ensure that municipalities and local authorities are sensitized about the accessibility principle , with a view to align ing relevant local and regional laws, such as building and planning codes, in accordance with article 9 of the Convention; that they have the necessary funding and guidance to monitor , evaluate and secure full accessibility to buildings ; and that the reasonable accommodation needs of persons with disabilities are integrated in municipal planning as appropriate . The Committee fu rther recommends that accessibility requirements be systematically included in all public procurement agreements .",
    projectIds: [1, 3, 5]
  },
  {
    id: 101,
    name: "28. The Committee encourages the State party to supplement the regulatory framework concerning the public sector’s responsibility to present its information and communications in accessible formats.",
    projectIds: [1, 3, 5]
  },
  {
    id: 102,
    name: "30. The Committee urges the State party to adopt all necessary measures to prevent, identify and address situations of risk of suicide in persons with disabilities, including boys and girls.",
    projectIds: [1, 3, 5]
  },
  {
    id: 103,
    name: "32. The Committee recommends that the State party undertake to ensure that disaster risk reduction is fully accessible and disability inclusive , and take measures to ensure its preparedness to provide persons with disabilities with the necessary support in the event of a disaster.",
    projectIds: [1, 3, 5]
  },
  {
    id: 104,
    name: "In the light of its general comment No. 12 (2009) on the right of the child to be heard, the Committee recommends that the State party take measures to strengthen that right in accordance with article 12 of the Convention and to ensure the effective implementation of legislation recognizing the right of the child to be heard in relevant legal proceedings, including by establishing systems and/or procedures for social workers and courts to comply with the principle. The Committee also calls upon the State party to take prompt legal measures to amend chapter 1, section 11, of the Aliens Act, abolish the exception of inappropriateness, and ensure that a child is heard whenever a decision affecting him or her is made. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 105,
    name: "The Committee encourages the State party to increase the allocation of human, technical and financial resources to helplines to provide a nationwide 24-hour service.",
    projectIds: [1, 3, 5]
  },
  {
    id: 106,
    name: "The Committee recommends that the State party take all the necessary measures to enable children with parents in prison to maintain personal relations and direct contact with them, and systematically apply the principle of closeness. The Committee also encourages the State party to continue to increase child-friendly visiting facilities in prisons.",
    projectIds: [1, 3, 5]
  },
  {
    id: 107,
    name: "The Committee recommends that the State party fully regulate practices relating to the removal of children from their families and ensure that removal is always subject to thorough investigation, is in accordance with the best interests of the child and is used as a measure of last resort.",
    projectIds: [1, 3, 5]
  },
  {
    id: 108,
    name: "9. The Committee reiterates its recommendation (see CCPR/C/SWE/CO/6, para. 4) that the State party establish, without undue delay, an independent national human rights institution invested with a broad human rights mandate and provide it with adequate financial and human resources, in accordance with the principles relating to the status of national institutions for the promotion and protection of human rights (the Paris Principles).",
    projectIds: [1, 3, 5]
  },
  {
    id: 109,
    name: "11. The State party should consider, in the framework of the current review of its anti-discrimination legislation, expanding the scope of protection against discrimination under its domestic law by, inter alia, introducing a prohibition of discrimination in all spheres and sectors in full compliance with the anti-discrimination provisions of the Covenant. The State party should also improve the accessibility of effective remedies against any form of discrimination, including by considering expanding the mandate of the Equality Ombudsman to all forms of discrimination and expanding the legal aid criteria to enable victims of discrimination to pursue their cases in court where the interests of justice so require.",
    projectIds: [1, 3, 5]
  },
  {
    id: 110,
    name: "13. The State party should strengthen the measures taken to improve equal access of persons with disabilities to employment, education, health care, justice and governmental services, without any discrimination.",
    projectIds: [1, 3, 5]
  },
  {
    id: 111,
    name: "15. The State party should take all measures necessary to ensure equal access by Roma to various opportunities and services, including to education, employment, housing and health care, without discrimination. It should also ensure that all individuals within its jurisdiction, including vulnerable Roma citizens of other European Union countries, enjoy equal rights without discrimination and identify ways to facilitate their access to support assistance services, including social benefits, taking into account both their de jure and de facto situation. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 112,
    name: "17. The State party should redouble its efforts, both through law enforcement activities and awareness-raising, to combat hate speech, including on the Internet, racist and xenophobic violence against and negative stereotyping and portrayal of ethnic or religious minorities, in accordance with articles 19 and 20 of the Covenant and the Committee’s general comment No. 34 (2011) on freedoms of opinion and expression. It should, inter alia: (a) institute new awareness-raising campaigns aimed at promoting respect for human rights and tolerance for diversity and targeted at revisiting and eradicating stereotypes towards different ethnic or religious minorities; and (b) effectively implement the legal and policy frameworks to counter all manifestations of racism, hatred and xenophobia, including by thoroughly investigating such cases, prosecuting suspected perpetrators where appropriate and, if they are convicted, punishing them and providing victims with adequate remedies.",
    projectIds: [1, 3, 5]
  },
  {
    id: 113,
    name: "19. The State party should step up its efforts with a view to promoting women’s equal access to full-time employment and to eliminating the gender wage gap by tackling vertical and horizontal segregation in employment and addressing differences in pay between men and women for the same work.",
    projectIds: [1, 3, 5]
  },
  {
    id: 114,
    name: "23. The State party should pursue its plans to review comprehensively the counter-terrorism legislation and ensure that any existing and future counter-terrorism legislation and practices are in full conformity with the State party’s obligations under the Covenant, including with the principle of non-discrimination and the right to liberty and security. It should, inter alia, ensure that the principles of necessity and proportionality are strictly observed in the application of arrest powers under the Terrorism Act, and take effective measures to prevent different treatment by law enforcement officials of criminal suspects by reason of their religion and/or ethnicity, including by providing appropriate training on cultural awareness and the inadmissibility of racial profiling. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 115,
    name: "25. The State party should:",
    projectIds: [1, 3, 5]
  },
  {
    id: 116,
    name: "(a) Undertake regular reviews of measures employed in law enforcement operations, including types of firearms and ammunition used, with a view to ensuring the application of least harmful means in all circumstances;",
    projectIds: [1, 3, 5]
  },
  {
    id: 117,
    name: "(b) Ensure that law enforcement officers receive appropriate professional training, including on how to avoid excessive use of force and how to handle persons with mental disabilities; ",
    projectIds: [1, 3, 5]
  },
  {
    id: 118,
    name: "(c) Review its position vis-à-vis the operation of the Department of Special Investigations under the administrative framework of the Swedish Police Authority to ensure that the body entrusted to investigate complaints against the police is truly independent of the police and is perceived as such;",
    projectIds: [1, 3, 5]
  },
  {
    id: 119,
    name: "(d) Ensure that reported cases of excessive use of force are independently and effectively investigated; that alleged perpetrators are prosecuted and, if convicted, punished with appropriate sanctions; and that victims or their families are provided with redress, including adequate compensation.",
    projectIds: [1, 3, 5]
  },
  {
    id: 120,
    name: "27. The State party should take expeditious measures to include in its Criminal Code a definition of torture that is fully in line with article 7 of the Covenant and internationally established norms, including with respect to an appropriate statute of limitations for the grave crime of torture. ",
    projectIds: [1, 3, 5]
  },
  {
    id: 121,
    name: "29. The State party should bring its legislation and practices into compliance with article 9 of the Covenant, taking into account the Committee’s general comment No. 35 (2014) on liberty and security of persons. The State party should, inter alia:",
    projectIds: [1, 3, 5]
  },
  {
    id: 122,
    name: "(a) Establish a statutory time limit on the duration of pretrial detention and ensure that pretrial detention constitutes an exceptional measure and that, in practice, priority is given to alternative measures to detention;",
    projectIds: [1, 3, 5]
  },
  {
    id: 123,
    name: "(b) Ensure that all persons are afforded, in practice, the right to a counsel from the very outset of their deprivation of liberty;",
    projectIds: [1, 3, 5]
  },
  {
    id: 124,
    name: "(c) Ensure that all restrictions on contacts for pretrial detainees are time-bound and are justified as necessary and proportionate in the light of all the relevant circumstances; that the scope and the extent of their application is subject to constant review; and that appropriate measures to mitigate isolation are provided, in particular for young detainees.",
    projectIds: [1, 3, 5]
  },
];

export const SDGs = [
  {
    index: 1,
    title: "1. NO POVERTY",
    goal: "End poverty in all its forms everywhere",
    image: "1.png",
    color: "#E5233B",
    subSdgs: [
      "1.1 - Eradicate extreme poverty",
      "1.2 - Reduce poverty at least by 50%",
      "1.3 - Implement social protection systems",
      "1.4 - Equal rights to ownership, basic services, technology and economic resources",
      "1.5 - Build resilience to environmental, economic and social disasters",
      "1.a - Mobilize resources to implement policies to end poverty",
      "1.b - Create pro-poor and gender-sensitive policy frameworks",
    ]
  },
  {
    index: 2,
    title: "2. ZERO HUNGER",
    goal: "End hunger, achieve food security and improved nutrition and promote sustainable agriculture",
    image: "2.png",
    color: "#DDA839",
    subSdgs: [
      "2.1 - Universal access to safe and nutritious food",
      "2.2 - End all forms of malnutrition",
      "2.3 - Double the productivity and incomes of small-scale food producers",
      "2.4 - Sustainable food production and resilient agricultural practices",
      "2.5 - Ensure genetic diversity in food production",
      "2.a - Invest in rural infrastructure, agricultural research, technology and gene banks",
      "2.b - Prevent agricultural trade restrictions, market distortions and export subsidies",
      "2.c - Ensure stable food commodity markets and timely access to information",
    ]
  },
  {
    index: 3,
    title: "3. GOOD HEALTH AND WELL-BEING",
    goal: "Ensure healthy lives and promote well-being for all at all ages",
    image: "3.png",
    color: "#4D9F39",
    subSdgs: [
      "3.1 - Reduce maternal mortality",
      "3.2 - End all preventable deaths under 5 years of age",
      "3.3 - Fight communicable diseases",
      "3.4 - Reduce mortality from non-communicable diseases and promote mental health",
      "3.5 - Prevent and treat substance abuse",
      "3.6 - Reduce road injuries and deaths",
      "3.7 - Universal access to reproductive care, planning and education",
      "3.8 - Achieve universal health coverage",
      "3.9 - Reduce illnesses and death from hazardous chemicals and pollution",
      "3.a - Implement the WHO framework on tobacco",
      "3.b - Support research, development and universal access to affordable vaccines and medicines",
      "3.c - Increase health financing and workforce support for developing countries",
      "3.d - Improve early warning systems for global health risks",
    ]
  },
  {
    index: 4,
    title: "4. QUALITY EDUCATION",
    goal: "Ensure inclusive and equitable quality education and promote lifelong opportunities for all",
    image: "4.png",
    color: "#C5182D",
    subSdgs: [
      "4.1 - Free primary and secondary education",
      "4.2 - Equal access to quality pre-primary education",
      "4.3 - Equal access to affordable technical, vocational and higher education",
      "4.4 - Increase the number of people with relevant skills for financial success",
      "4.5 - No discrimination in education",
      "4.6 - Universal literacy and numeracy",
      "4.7 - Education for sustainable development and global citizenship",
      "4.a - Build and upgrade inclusive and safe schools",
      "4.b - Expand higher education scholarships for developing countries",
      "4.c - Increase the supply of qualified teachers in developing countries",
    ]
  },
  {
    index: 5,
    title: "5. GENDER EQUALITY",
    goal: "Achieve gender equality and empower all women and girls",
    image: "5.png",
    color: "#FF3A21",
    subSdgs: [
      "5.1 - End discrimination against women and girls",
      "5.2 - End all violence against and exploitation of women ",
      "5.3 - Eliminate forced marriages and genital mutilation",
      "5.4 - Value unpaid care and promote shared domestic responsibilities",
      "5.5 - Equal opportunities and participation in leadership",
      "5.6 - Universal access to reproductive health and rights",
      "5.a - Equal rights to economic resources, property ownership and financial services",
      "5.b - Promote empowerment of women through technology",
      "5.c - Adopt policies and enforce legislation for gender equality",
    ]
  },
  {
    index: 6,
    title: "6. CLEAN WATER AND SANITATION",
    goal: "Ensure availability and sustainable management of water and sanitation for all",
    image: "6.png",
    color: "#27BDE2",
    subSdgs: [
      "6.1 - Safe and affordable drinking water",
      "6.2 - End open defecation and provide access to sanitation and hygiene",
      "6.3 - Improve water quality, wastewater treatment and safe reuse",
      "6.4 - Increase water-use efficiency and ensure freshwater supplies",
      "6.5 - Integrated water resources management and transboundary cooperation",
      "6.6 - Protect and restore water-related ecosystems",
      "6.a - Expand water- and sanitation-related support for developing countries",
      "6.b - Support local engagement in water and sanitation management",
    ]
  },
  {
    index: 7,
    title: "7. AFFORDABLE AND CLEAN ENERGY",
    goal: "Ensure access to affordable, reliable, sustainable and modern energy for all",
    image: "7.png",
    color: "#FCC30D",
    subSdgs: [
      "7.1 - Universal access to modern energy",
      "7.2 - Increase global percentage of renewable energy",
      "7.3 - Double the improvement in energy efficiency",
      "7.a - Invest in and facilitate access to clean energy research and technology",
      "7.b - Expand and upgrade energy services for developing countries",
    ]
  },
  {
    index: 8,
    title: "8. DECENT WORK AND ECONOMIC GROWTH",
    goal: "Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all",
    image: "8.png",
    color: "#A21942",
    subSdgs: [
      "8.1 - Sustainable economic growth",
      "8.2 - Diversify, innovate and upgrade for economic productivity",
      "8.3 - Promote policies to support job creation and growing enterprises",
      "8.4 - Improve resource efficiency in consumption and production",
      "8.5 - Full employment and decent work with equal pay",
      "8.6 - Promote youth employment, education and training",
      "8.7 - End modern slavery, trafficking and child labour",
      "8.8 - Universal labour rights and safe working environments",
      "8.9 - Promote beneficial and sustainable tourism",
      "8.10 - Universal access to banking, insurance and financial services",
      "8.a - Increase aid for trade support for developing countries",
      "8.b - Develop a global youth employment strategy",
    ]
  },
  {
    index: 9,
    title: "9. INDUSTRY, INNOVATION AND INFRASTRUCTURE",
    goal: "Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation",
    image: "9.png",
    color: "#FD6925",
    subSdgs: [
      "9.1 - Develop sustainable, resilient and inclusive infrastructures",
      "9.2 - Promote inclusive and sustainable industrialization",
      "9.3 - Increased access to financial services and markets",
      "9.4 - Upgrade all industries and infrastructures for sustainability",
      "9.5 - Increase research and upgrade industrial technologies",
      "9.a - Facilitate sustainable infrastructure development",
      "9.b - Support domestic industrial diversification and value addition",
      "9.c - Universal access to information and communications technology",
    ]
  },
  {
    index: 10,
    title: "10. REDUCED INEQUALITIES",
    goal: "Reduce inequality within and among countries",
    image: "10.png",
    color: "#DD1467",
    subSdgs: [
      "10.1 - Reduce income inequalities",
      "10.2 - Promote universal social, economical and political inclusion",
      "10.3 - Ensure equal opportunities and end discrimination",
      "10.4 - Adopt fiscal and social policies that promote equality",
      "10.5 - Improve regulation of global financial markets and institutions",
      "10.6 - Ensure representation for developing countries in financial institutions",
      "10.7 - Responsible and well-managed migration policies",
      "10.a - Special and differential treatment for developing countries",
      "10.b - Encourage development assistance and investment in least developed countries",
      "10.c - Reduce transaction costs for migrants remittances",
    ]
  },
  {
    index: 11,
    title: "11. SUSTAINABLE CITIES AND COMMUNITIES",
    goal: "Make cities and human settlements inclusive, safe, resilient and sustainable",
    image: "11.png",
    color: "#FE9D25",
    subSdgs: [
      "11.1 - Safe and affordable housing ",
      "11.2 - Affordable and sustainable transport systems",
      "11.3 - Inclusive and sustainable urbanization",
      "11.4 - Protect the world's cultural and natural heritage",
      "11.5 - Reduce the adverse effects of natural disasters",
      "11.6 - Minimize the environmental impact of cities",
      "11.7 - Build safe and inclusive green public spaces",
      "11.a - Strong national and regional development planning",
      "11.b - Implement policies for inclusion, resource efficiency and disaster risk reduction",
      "11.c - Support least developed countries in sustainable and resilient building",
    ]
  },
  {
    index: 12,
    title: "12. RESPONSIBLE CONSUMPTION AND PRODUCTION",
    goal: "Ensure sustainable consumption and production patterns",
    image: "12.png",
    color: "#BF8B2E",
    subSdgs: [
      "12.1 - Implement the 10-year sustainable consumption and production framework",
      "12.2 - Sustainable management and use of natural resources",
      "12.3 - Halve global per capita food waste",
      "12.4 - Responsible management of chemicals and waste",
      "12.5 - Substantially reduce waste generation",
      "12.6 - Encourage sustainable practices for companies",
      "12.7 - Sustainable public procurement practices",
      "12.8 - Promote universal understanding of sustainable lifestyles",
      "12.a - Support developing countries' scientific and technological capacity of sustainable consumption and production",
      "12.b - Develop and implement tools to monitor sustainable tourism",
      "12.c - Remove market distortions that encourage wasteful consumption",
    ]
  },
  {
    index: 13,
    title: "13. CLIMATE ACTION",
    goal: "Take urgent action to combat climate change and its impacts",
    image: "13.png",
    color: "#3F7F44",
    subSdgs: [
      "13.1 - Strengthen resilience and adaptive capacity to climate related disasters",
      "13.2 - Integrate climate change measures",
      "13.3 - Build knowledge and capacity to meet climate change challenges",
      "13.a - Implement the UN framework Convention for planning and management",
      "13.b - Promote mechanisms to raise capacity for planning and management",
    ]
  },
  {
    index: 14,
    title: "14. LIFE BELOW WATER",
    goal: "Conserve and sustainably use the oceans, seas and marine resources for sustainable development",
    image: "14.png",
    color: "#0A97D9",
    subSdgs: [
      "14.1 - Reduce marine pollution",
      "14.2 - Protect and restore ecosystems",
      "14.3 - Reduce ocean acidification",
      "14.4 - Sustainable fishing",
      "14.5 - Conserve coastal and marine areas",
      "14.6 - End subsidies contributing to overfishing",
      "14.7 - Encourage sustainable use of marine resources",
      "14.a - Increase scientific knowledge, research and technology for ocean health",
      "14.b - Support small scale fishers",
      "14.c - Implement and enforce international sea law",
    ]
  },
  {
    index: 15,
    title: "15. LIFE ON LAND",
    goal: "Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, combat desertification, and halt and reverse land degradation and halt biodiversity loss",
    image: "15.png",
    color: "#56C02A",
    subSdgs: [
      "15.1 - Conserve and restore terrestrial and freshwater ecosystems",
      "15.2 - Sustainably manage all forests",
      "15.3 - Stop desertification and restore degraded land",
      "15.4 - Ensure conservation of mountain ecosystems",
      "15.5 - Protect biodiversity and natural habitats",
      "15.6 - Promote fair share of benefits from, and access to genetic resources",
      "15.7 - Eliminate poaching and trafficking of protected species",
      "15.8 - Prevent invasive alien species on land and in water ecosystems",
      "15.9 - Integrate ecosystem and biodiversity in governmental planning",
      "15.a - Increase financial resources to conserve and sustainably use ecosystem and biodiversity",
      "15.b - Finance and incentivize sustainable forest management",
      "15.c - Combat global poaching and trafficking",
    ]
  },
  {
    index: 16,
    title: "16. PEACE, JUSTICE AND STRONG INSTITUTIONS",
    goal: "Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels",
    image: "16.png",
    color: "#03689D",
    subSdgs: [
      "16.1 - Reduce violence everywhere",
      "16.2 - Protect children from abuse, exploitation, trafficking and violence",
      "16.3 - Promote the rule of law and access to justice for all",
      "16.4 - Combat organized crime and illicit financial and arms flows",
      "16.5 - Reduce corruption and bribery",
      "16.6 - Effective, accountable and transparent institutions",
      "16.7 - Responsive, inclusive and representative decision-making",
      "16.8 - Full participation of developing countries in global governance",
      "16.9 - Universal legal identity and birth registration",
      "16.10 - Ensure public access to information and protect fundamental freedoms",
      "16.a - Strong institutions to prevent violence, terrorism and crime",
      "16.b - Promote and enforce non-discriminatory laws",
    ]
  },
  {
    index: 17,
    title: "17. PARTNERSHIPS FOR THE GOALS",
    goal: "Strengthen the means of implementation and revitalize the Global Partnership for Sustainable Development",
    image: "17.png",
    color: "#19486A",
    subSdgs: [
      "17.1 - Improve domestic capacity for revenue collection",
      "17.2 - Implement all development assistance commitments",
      "17.3 - Mobilize financial resources for developing countries",
      "17.4 - Assist developing countries in attaining debt sustainability",
      "17.5 - Implement investment promotion regimes",
      "17.6 - Knowledge sharing and cooperation for access to science, technology and innovation",
      "17.7 - Promote sustainable technologies to developing countries",
      "17.8 - Operationalize the technology bank, build scientific capacity and enhance information and communication technology",
      "17.9 - Enhance capacity-building in developing countries",
      "17.10 - Promote a universal trading system under the WTO",
      "17.11 - Increase the exports of developing countries",
      "17.12 - Provide market access for least developed countries",
      "17.13 - Enhance global macroeconomic stability",
      "17.14 - Enhance policy coherence for sustainable development",
      "17.15 - Respect national leadership to implement policies for the Sustainable Development Goals",
      "17.16 - Enhance the global partnership for sustainable development",
      "17.17 - Encourage effective partnerships",
      "17.18 - Enhance availability of reliable data",
      "17.19 - Further develop measurement of progress",
    ]
  },
];

export const RECOMMENDING_BODIES = [
  "Committee on the Elimination of Discrimination against Women (CEDAW)",
  "Committee on the Elimination of Racial Discrimination (CERD)",
  "Committee on the Rights of Persons with Disabilities (CRPD)"
];

export const UPDATES = [
  {
    id: 0,
    screenshotUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAwSSURBVFhHlVd5bBz1Ff5md/a+vbZje2PHju1czU1IEAEUUo5CIA2EHkhIPf5oVUoPUFWK1ArnX6AqraD9I1TQfyqQSkQPqrYqLailKpQjHCEhduI7Xh+76z1mr7n6vRnbJEpKw4s3O7O/md/75r3vfe+Ngk9oCzMz9onxKUwsFqHDRi6fx/ZMC3x+FWFVxfy5WUxVLAyu7cXmdQNoT7d8Ih+XffErL71kHz/2e4wOj0DbfTX0SAQ9mVXweYA9vfwmGL9tIntmFG+eHAV0HUatinQ6iSuvuRb7b7jhsnz934veeudd++dHn8LCxCT6yxrsQBD61dchmIwjEQ4gSkTdMT/KjNQMrxk9O47CQg4FrYaqYcPjVRHw+bFpcC3u/ebXsXHbto/1+bGLz77wR/vXx34Dw9ARburoLyyi7POi3NpGJx7YzQYKTF25WkfDpHPVj6A/gFTAC7/XA69Xgc+nQPF6wRugBIPYd9Ot+MLBz/5Pv5dcKBRL9sM/fhyKGsbIxBhM00SwXkNl5BQmSwXYlu3c6fcH0dXZja6WOIKqh9FQYKkK1y0EY1EEWtIIRmPw8aP4/ajrJkoNA+lkC757+BAS0chF/i/6YbFYtL/32M8wdm4OfZkejI+egV2tYmF6DLXCHOiNV/E2/hEWo+DF9l070D3YT8dxmKEo9HIFquqFFQwxbRZqugWDIGGYUHm/n8drokHc99UvIxqLXYCBsbzQ6jqGRk+OwLvI9ExPQikXUVyYRbVcQAAmNsaDGEyGeKMCjc5MRstkqjJXXQvN40fFVFCtN9G0FJi2goBhIGY0kKxriJfz8OVnYM5NY/bsMN4fHsYrL79yZMm1Yxege+InT9h/evHPPLK5QI7wiPviXG4WzWoRMT71mkQItw1m8MFsHuMlDfmGiTkliOu/9BUE+eQ+vQGUFmFWK6gzzVqjgabJ6HhYjkybyqgpgQB0PozCAtm392rc85mbV3CsHBx/87g99NDDLj8EEDewbBsGzyazE+hORBBhhIKwcGVPB7a0RvD6VAE71rTjkX9/iK17ruQqr/d4YegGU0YZSCRhhWLklhceeiIE2NzT4j+NqfCbBkKxML5x+DAG1/Q6WFZS5jWUodJiCYwyTxgdAjKpK0LQYnkR1+/Yjj6W+kAygpZkG3Zu3ICt27agd+cevD9yFsVUB5KDGxBo64AnEkcg1QI1noTX56NGeeAn2YMkfdQHJKRCCTzmtbA6FUGhsIBjzz3vpI5xBF5+6e/2+BiryTJYURQ0ETWj6fDDSR6fMBFPYMemdVidyeAfFMd/vfUGKygOr6VDURRqzwL8kTACLO+g3wc/09Ee8qIn6kFv3Ide8q43HUZ3axxtqRhi8QgMrw8aVJyYyeH1kyclNW6EWpNtQ/O5RZY54Uuuid7JJr/FWaNZR4hPk1CZEpuRK5WxkTmYq5BX6RY8/dd/Qud21+zdhXSAQsiU2ORbZyrqgFMojnWGvtCwkK002HbqmKnoWMyXMFkxMFusYa5Qwqt/+O0RT3Yma586NUwwfvJGdT+KgHJJLbgC/hCmsrMoUnlPnJtBsarh3UoZIaWB9995G7PlGntclu3CYIQCaNK5RrIPL1Tw9nQRr43n8Z+xHN6dLGA4W8ZMoUoOGeQoYFIKFErByPgEZnN52/vp/TcOvf7aGw4QIuGiUFroRyMBJUJiMyx93TJRrfFp+NH51Lqi4tXhcYyW6k6aFytV9G8YwMTUHCoEn6/UUdbqqFHllx37uV+IHE35SQOziaRioUWvId6osBGn4L1i286hcxNnHQgeOgwpvFlAEYfJlqGzPTSaVVTYKLNsHSQWcmwVowzxO9NzGCuzzAU+ozrPKPUNrKUIKk5ZN6lHUaa2I6iiK+RDmnWY0KvwUUKaJHJldhpl6ly+XEaxlIPKAlAe+va9dm5mGtO5Kmr1BuIBRoMpaAqx2TIsgpTciQSYPI4H/FgVCSJgNZ3mWSIpy2wJisfnlLTKXhaOxdHgXobelDAjGY8h3Z6GP5VmCwnBZrO1WE9qrUJRZaQrBViNOgmfYlAqC7B1DVUtj0WtwOqqo0kSsyshzIqJhIKIRcPOeCHpq1N509SOzZk0uklaMdEuASO80xnVYj6HhlaC2WRqqdD5XA7Dp06jolOHIkkCCsJkwdQIqsHC0NgVtEIeY2fOwrt13eqhJnMcCbJD+1R0puMoGB5EW1ch1bcedqIV4a41AFNXq9AJnUcZpUQ4ROH1Y4Ipawg/nCIQFSHvnH4nQKljBCqiKKBLc1lEu7pZgSosRr9emEeDqbOo6lWqe02rwlNvUm84+6WTUbRSpKLs3sFd+xHfdT06N2xFe1sbOmIBqOxHEiH5TJI/Vd7X2p6BKRUpzp3/HTY5IGwRVQJzzpcWLLaV7Im35QwBvQ6rmEOTQBRGs1mrOw/rCahRovWgwp4jm1hGDSmliTZtFsr8JMJGFeEa9Yb6ImBk843967Hvls9j/b6DHAx1F4VjssroOOciqjzkPY4JSH5pszNQp84iNj9OcpcQZqVZzJDC9RDp4Ykn0tCqLGf2FrnBb9WxqjSOsF5B1KYgGhpC7GjOvMO0hIJh3HLgDrQwnRPzc1RkVgERiKLLpuLYcS4iwz8HkJwzWg7PaOMffoDFbJZkrlC7mk4bDzGvqzu74Gnr7qFOGLzYTYfBylHYNgINCh8j46kwrBw9GixlAdTbO+DwK9LeiZOnTsJg6rxU+CjbiBOdFXMj4oIQQALZNa2hMyOUBPY3lWsBqnqI/F3fvxaedVu2kUGsHt2DfLHKt4gc6pwKtVwW56YmUCtV+Lvmzjck4pqePgSi7EPseyOnCYgcyvR9CqqMqeJcHDtpks5OyXDAMDpytLQuvxWbnByoO2EWiFRykn3wil274Nm95ypn5vVSeWXoMin5Za2JElNYorAVeKwzgjo3kigmOFIEOBufGx9HnS1E9jdqJTQaNcmP43Q5NbJoyaS4dOz+c63MPdna2JbcOVx+37F7DzydmYyyefNmJ+d+9rMatUyrm2wDTYobgZBw1WqNqXTJGo5SezjHpLpWsyo4PvQNYO++G2EzeuJ0mTNicnw+dxyvAoz32dwjW2Nn4FTAzHGU2Y6OroxbswfvPOzMPtIypFC9cqc8GT8NNkyd7aLBalIUL18IGeJkipjIO240deYU/vaXFxGPpxCJJpwoiblpE/9LEXNP3QjJGl0X2ROzpEOBr1fX3Xqbs+4A2n/jzcqqzozzVlAj2XQSW+PbQZ1RUdkIhXSygTjxUNRE8AzKhKTZYlTDsSSrLwIfzyUC4lCuFb8rgJw/th8qubQUk4Uj7WiB72+b1nTh2htuciC7qkb72n3fIQCqJ98Qanx6EakmPzIOx9mZBYSfua6RN0W+FDokdlwAEyPvscOP8PUp5+zlmgBy5ykXFAdXpmnZ5NykUJbIpXseeHDp1/MA7dq9Rzlw+yEOYC4IU27gsczIJhtngxGRbrxA/QiEOV0TYLnMkbdede5fSZEcO0fyG7WLHwG0Qm6ah5oj0fVw7zvuPIT1O3cv3/IRILH7v/8DZePGTdxVwADRVCsszklVqoWXv4kOLVAWmgSXoygajOT5XFk2OXLP+XFS516jEICXY6sAlfWtW7fgyJEjK2DELgAk9sjjP0VXT48zzUmH72hvZ0Q4C6f5BkFQ9ZrmACsUODLIRUvmAODnAmBy6LgTUZU3D84Q1C+5pr+/H08++aQsXmAXAWppSSu/+OXTLEMKJmcUGUl7OjJoT6UYGb4AsupkOmxwTXHGy48UWHgh0ZXfXHbJugRJALmjsQDbsmULnnnmaaTT6QuiI3YRIDEBdfSZXykHDt4u1ETYryLFzq6ThIGQ8IeEZ9rEHBDuwdKX6I4LyjX6JBAHGUXlrrsO47nnnlUuBUbskoCW7Vv3P6A8+KMford/ECpLW3zkFrLIzc1zPHXHkWVb5oVj/JKSdmPnRq2vrxdHjz5FzgxdEsiyfezi+Xb8+Hv2o489itOnh3Hots+hUsrjhRePcUVIS41i5bgDGaVVIuKAVbCTL5h33/1FHDhw4LJ8XTagZZucnLTHzo5jYmwSx373PLKUAY2TngCIsEGuWtWOgYFBAtmBvXxv7+7u/gQ+gP8CfeA/duVXAnkAAAAASUVORK5CYII=",
    name: 'Alex Thomas',
    action: 'changed the budget',
    date: '03:40PM',
    propertyName: 'Budget',
    propertyValue: '150 000'
  },
  {
    id: 1,
    screenshotUrl: "data:image/png;base64,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",
    name: 'Alex Thomas',
    action: 'removed an implementing parter',
    date: 'Yesterday, 07:12PM',
    propertyName: 'Implementing partners',
    propertyValue: 'Lorem ipsum dolor'
  },
  {
    id: 2,
    screenshotUrl: "data:image/png;base64,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",
    name: 'Alex Thomas',
    action: 'added a comment',
    date: '16 Dec 2021',
    details: 'Business cards represent not only your business, but it also tells people your professionalism in the industry. In the business world today, the usage of business cards is far beyond just informing people who you are,'
  },
  {
    id: 3,
    screenshotUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAwSSURBVFhHlVd5bBz1Ff5md/a+vbZje2PHju1czU1IEAEUUo5CIA2EHkhIPf5oVUoPUFWK1ArnX6AqraD9I1TQfyqQSkQPqrYqLailKpQjHCEhduI7Xh+76z1mr7n6vRnbJEpKw4s3O7O/md/75r3vfe+Ngk9oCzMz9onxKUwsFqHDRi6fx/ZMC3x+FWFVxfy5WUxVLAyu7cXmdQNoT7d8Ih+XffErL71kHz/2e4wOj0DbfTX0SAQ9mVXweYA9vfwmGL9tIntmFG+eHAV0HUatinQ6iSuvuRb7b7jhsnz934veeudd++dHn8LCxCT6yxrsQBD61dchmIwjEQ4gSkTdMT/KjNQMrxk9O47CQg4FrYaqYcPjVRHw+bFpcC3u/ebXsXHbto/1+bGLz77wR/vXx34Dw9ARburoLyyi7POi3NpGJx7YzQYKTF25WkfDpHPVj6A/gFTAC7/XA69Xgc+nQPF6wRugBIPYd9Ot+MLBz/5Pv5dcKBRL9sM/fhyKGsbIxBhM00SwXkNl5BQmSwXYlu3c6fcH0dXZja6WOIKqh9FQYKkK1y0EY1EEWtIIRmPw8aP4/ajrJkoNA+lkC757+BAS0chF/i/6YbFYtL/32M8wdm4OfZkejI+egV2tYmF6DLXCHOiNV/E2/hEWo+DF9l070D3YT8dxmKEo9HIFquqFFQwxbRZqugWDIGGYUHm/n8drokHc99UvIxqLXYCBsbzQ6jqGRk+OwLvI9ExPQikXUVyYRbVcQAAmNsaDGEyGeKMCjc5MRstkqjJXXQvN40fFVFCtN9G0FJi2goBhIGY0kKxriJfz8OVnYM5NY/bsMN4fHsYrL79yZMm1Yxege+InT9h/evHPPLK5QI7wiPviXG4WzWoRMT71mkQItw1m8MFsHuMlDfmGiTkliOu/9BUE+eQ+vQGUFmFWK6gzzVqjgabJ6HhYjkybyqgpgQB0PozCAtm392rc85mbV3CsHBx/87g99NDDLj8EEDewbBsGzyazE+hORBBhhIKwcGVPB7a0RvD6VAE71rTjkX9/iK17ruQqr/d4YegGU0YZSCRhhWLklhceeiIE2NzT4j+NqfCbBkKxML5x+DAG1/Q6WFZS5jWUodJiCYwyTxgdAjKpK0LQYnkR1+/Yjj6W+kAygpZkG3Zu3ICt27agd+cevD9yFsVUB5KDGxBo64AnEkcg1QI1noTX56NGeeAn2YMkfdQHJKRCCTzmtbA6FUGhsIBjzz3vpI5xBF5+6e/2+BiryTJYURQ0ETWj6fDDSR6fMBFPYMemdVidyeAfFMd/vfUGKygOr6VDURRqzwL8kTACLO+g3wc/09Ee8qIn6kFv3Ide8q43HUZ3axxtqRhi8QgMrw8aVJyYyeH1kyclNW6EWpNtQ/O5RZY54Uuuid7JJr/FWaNZR4hPk1CZEpuRK5WxkTmYq5BX6RY8/dd/Qud21+zdhXSAQsiU2ORbZyrqgFMojnWGvtCwkK002HbqmKnoWMyXMFkxMFusYa5Qwqt/+O0RT3Yma586NUwwfvJGdT+KgHJJLbgC/hCmsrMoUnlPnJtBsarh3UoZIaWB9995G7PlGntclu3CYIQCaNK5RrIPL1Tw9nQRr43n8Z+xHN6dLGA4W8ZMoUoOGeQoYFIKFErByPgEZnN52/vp/TcOvf7aGw4QIuGiUFroRyMBJUJiMyx93TJRrfFp+NH51Lqi4tXhcYyW6k6aFytV9G8YwMTUHCoEn6/UUdbqqFHllx37uV+IHE35SQOziaRioUWvId6osBGn4L1i286hcxNnHQgeOgwpvFlAEYfJlqGzPTSaVVTYKLNsHSQWcmwVowzxO9NzGCuzzAU+ozrPKPUNrKUIKk5ZN6lHUaa2I6iiK+RDmnWY0KvwUUKaJHJldhpl6ly+XEaxlIPKAlAe+va9dm5mGtO5Kmr1BuIBRoMpaAqx2TIsgpTciQSYPI4H/FgVCSJgNZ3mWSIpy2wJisfnlLTKXhaOxdHgXobelDAjGY8h3Z6GP5VmCwnBZrO1WE9qrUJRZaQrBViNOgmfYlAqC7B1DVUtj0WtwOqqo0kSsyshzIqJhIKIRcPOeCHpq1N509SOzZk0uklaMdEuASO80xnVYj6HhlaC2WRqqdD5XA7Dp06jolOHIkkCCsJkwdQIqsHC0NgVtEIeY2fOwrt13eqhJnMcCbJD+1R0puMoGB5EW1ch1bcedqIV4a41AFNXq9AJnUcZpUQ4ROH1Y4Ipawg/nCIQFSHvnH4nQKljBCqiKKBLc1lEu7pZgSosRr9emEeDqbOo6lWqe02rwlNvUm84+6WTUbRSpKLs3sFd+xHfdT06N2xFe1sbOmIBqOxHEiH5TJI/Vd7X2p6BKRUpzp3/HTY5IGwRVQJzzpcWLLaV7Im35QwBvQ6rmEOTQBRGs1mrOw/rCahRovWgwp4jm1hGDSmliTZtFsr8JMJGFeEa9Yb6ImBk843967Hvls9j/b6DHAx1F4VjssroOOciqjzkPY4JSH5pszNQp84iNj9OcpcQZqVZzJDC9RDp4Ykn0tCqLGf2FrnBb9WxqjSOsF5B1KYgGhpC7GjOvMO0hIJh3HLgDrQwnRPzc1RkVgERiKLLpuLYcS4iwz8HkJwzWg7PaOMffoDFbJZkrlC7mk4bDzGvqzu74Gnr7qFOGLzYTYfBylHYNgINCh8j46kwrBw9GixlAdTbO+DwK9LeiZOnTsJg6rxU+CjbiBOdFXMj4oIQQALZNa2hMyOUBPY3lWsBqnqI/F3fvxaedVu2kUGsHt2DfLHKt4gc6pwKtVwW56YmUCtV+Lvmzjck4pqePgSi7EPseyOnCYgcyvR9CqqMqeJcHDtpks5OyXDAMDpytLQuvxWbnByoO2EWiFRykn3wil274Nm95ypn5vVSeWXoMin5Za2JElNYorAVeKwzgjo3kigmOFIEOBufGx9HnS1E9jdqJTQaNcmP43Q5NbJoyaS4dOz+c63MPdna2JbcOVx+37F7DzydmYyyefNmJ+d+9rMatUyrm2wDTYobgZBw1WqNqXTJGo5SezjHpLpWsyo4PvQNYO++G2EzeuJ0mTNicnw+dxyvAoz32dwjW2Nn4FTAzHGU2Y6OroxbswfvPOzMPtIypFC9cqc8GT8NNkyd7aLBalIUL18IGeJkipjIO240deYU/vaXFxGPpxCJJpwoiblpE/9LEXNP3QjJGl0X2ROzpEOBr1fX3Xqbs+4A2n/jzcqqzozzVlAj2XQSW+PbQZ1RUdkIhXSygTjxUNRE8AzKhKTZYlTDsSSrLwIfzyUC4lCuFb8rgJw/th8qubQUk4Uj7WiB72+b1nTh2htuciC7qkb72n3fIQCqJ98Qanx6EakmPzIOx9mZBYSfua6RN0W+FDokdlwAEyPvscOP8PUp5+zlmgBy5ykXFAdXpmnZ5NykUJbIpXseeHDp1/MA7dq9Rzlw+yEOYC4IU27gsczIJhtngxGRbrxA/QiEOV0TYLnMkbdede5fSZEcO0fyG7WLHwG0Qm6ah5oj0fVw7zvuPIT1O3cv3/IRILH7v/8DZePGTdxVwADRVCsszklVqoWXv4kOLVAWmgSXoygajOT5XFk2OXLP+XFS516jEICXY6sAlfWtW7fgyJEjK2DELgAk9sjjP0VXT48zzUmH72hvZ0Q4C6f5BkFQ9ZrmACsUODLIRUvmAODnAmBy6LgTUZU3D84Q1C+5pr+/H08++aQsXmAXAWppSSu/+OXTLEMKJmcUGUl7OjJoT6UYGb4AsupkOmxwTXHGy48UWHgh0ZXfXHbJugRJALmjsQDbsmULnnnmaaTT6QuiI3YRIDEBdfSZXykHDt4u1ETYryLFzq6ThIGQ8IeEZ9rEHBDuwdKX6I4LyjX6JBAHGUXlrrsO47nnnlUuBUbskoCW7Vv3P6A8+KMford/ECpLW3zkFrLIzc1zPHXHkWVb5oVj/JKSdmPnRq2vrxdHjz5FzgxdEsiyfezi+Xb8+Hv2o489itOnh3Hots+hUsrjhRePcUVIS41i5bgDGaVVIuKAVbCTL5h33/1FHDhw4LJ8XTagZZucnLTHzo5jYmwSx373PLKUAY2TngCIsEGuWtWOgYFBAtmBvXxv7+7u/gQ+gP8CfeA/duVXAnkAAAAASUVORK5CYII=",
    name: 'Alex Thomas',
    action: 'created this activity',
    date: '10 Dec 2021',
  }
];

export const MECHANISMS_DATES_RECOMMENDATIONS = [
  {
    id: 0,
    title: 'Committee on the Elimination of Discrimination against Women (CEDAW)‎',
    dates: [
      {
        dateString: '03/2016',
        opened: true,
        recommendations: [
          {
            id: 0,
            title: '41. The Committee calls for the realization of substantive gender equality, in accordance with the provisions of the Convention, throughout the process of implementation of the 2030 Agenda for Sustainable Development.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 2, 3, 5]
              },
              {
                index: 6, sugSdgIndexes: [3, 6]
              },

            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: true
          },
          {
            id: 1,
            title: '42. The Committee requests the State party to ensure the timely dissemination of the present concluding observations, in the official language of the State party, to the relevant state institutions at all levels (national, regional, local), in particular to the Government, the ministries, the parliament and the judiciary, to enable their full implementation.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 2, 3, 5]
              },
              {
                index: 6, sugSdgIndexes: [3, 6]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: true
          },
          {
            id: 2,
            title: '43. The Committee notes that the adherence of the State party to the nine major international human rights instruments would enhance the enjoyment by women of their human rights and fundamental freedoms in all aspects of life. The Committee therefore encourages the State party to consider ratifying the International Convention for the Protection of All Persons from Enforced Disappearance and the International Convention on the Protection of the Rights of All Migrant Workers and Members of Their Families, to which it is not yet a party.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 3,
            title: '44. The Committee requests the State party to provide, within two years, written information on the steps taken to implement the recommendations contained in paragraphs 11 (a), (b) and (c) and 27 (a) and (c) above.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          }
        ]
      }
    ]
  },
  {
    id: 1,
    title: 'Committee against Torture (CAT)‎‎',
    dates: [
      {
        dateString: '03/2016',
        opened: true,
        recommendations: [
          {
            id: 0,
            title: '45. The Committee invites the State party to submit its tenth periodic report in March 2020.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 1,
            title: 'Recalling its general recommendation No. 17 (1993) on the establishment of national institutions to facilitate the implementation of the Convention, the Committee recommends that the State party also consider establishing an independent national human rights institution for the protection and promotion of human rights in conformity with the Paris Principles, and provided with adequate financial and human resources in order to efficiently fight against discrimination.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 2,
            title: 'The Committee recommends that the State party develop a clear strategy to ensure scrutiny of the way police and prosecutors deal with hate crimes and that it replicate measures such as hate crime units and special investigators in all parts of the country. The State party should extend to all parts of the country the training given to the police, prosecutors and judges to effectively investigate, prosecute and punish hate crimes, in order to close the gap between reported incidents and convictions. The Committee reiterates its request that the State party introduce a common and clear definition of hate crime so that it is possible to track all such reported crimes through the justice system. The State party should also follow up on the report of its special investigator on further measures to combat xenophobia and similar forms of intolerance.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 3,
            title: 'Recalling its general recommendations No. 7 (1985) on legislation to eradicate racial discrimination and No. 30 (2004) on discrimination against non - citizens, the Committee recommends that the State party effectively investigate, prosecute and punish all hate crimes and take effective measures to combat hate speech in the media and on the Internet, including by prosecuting the perpetrators, where appropriate, regardless of their official status. The Committee urges the State party to take the necessary measures to promote tolerance, intercultural dialogue and respect for diversity, aiming those measures at journalists, inter alios.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          }
        ]
      }
    ]
  },
  {
    id: 2,
    title: 'Committee on Economic, Social and Cultural Rights (CESCR)‎',
    dates: [
      {
        dateString: '03/2016',
        opened: true,
        recommendations: [
          {
            id: 0,
            title: 'Drawing attention to general recommendation No. 15 (1993) on article 4 of the Convention, the Committee reiterates its previous recommendation that the State party amend its legislation to declare illegal and prohibit organizations promoting and inciting racial hatred, in line with article 4 (b) of the Convention.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 1,
            title: 'The Committee recommends that the State party study the causes of the 2013 riots with a view to assessing the effectiveness of its strategies against prevailing de facto segregation in Sweden along ethnic and socioeconomic lines, and the need for those strategies to be adjusted. The Committee also recommends that the State party take further legal and policy measures to address the problem of social exclusion and segregation along ethnic lines.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 2,
            title: '22. The Committee encourages the State party to create a strategy that increases public knowledge about different disabilities and to reinforce not only a positive but also an informative image of men and women with disabilities as dignified , independent and capable individuals who are holders of all the human rights recognized in the Convention , with the aim to remove sociocultural discrimination barriers in public life . The Committee further recommends that specific programmes be established, in consultation with disabled persons’ organizations, to raise awareness among public sector employees.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 3,
            title: '24. The Committee recommends that the State party launch periodic, regular and continuous national campaigns and other training courses targeted to public officials and private actors to enable them to be come acquainted with the general and specific contents of the Convention that have recently been incorporated into human rights law.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          }
        ]
      }
    ]
  },
  {
    id: 3,
    title: 'Human Rights Committee (CCPR)‎‎',
    dates: [
      {
        dateString: '03/2016',
        opened: true,
        recommendations: [
          {
            id: 0,
            title: '26. The Committee recommends that the State party ensure that municipalities and local authorities are sensitized about the accessibility principle , with a view to align ing relevant local and regional laws, such as building and planning codes, in accordance with article 9 of the Convention; that they have the necessary funding and guidance to monitor , evaluate and secure full accessibility to buildings ; and that the reasonable accommodation needs of persons with disabilities are integrated in municipal planning as appropriate . The Committee fu rther recommends that accessibility requirements be systematically included in all public procurement agreements .',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 1,
            title: '30. The Committee urges the State party to adopt all necessary measures to prevent, identify and address situations of risk of suicide in persons with disabilities, including boys and girls.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 2,
            title: '32. The Committee recommends that the State party undertake to ensure that disaster risk reduction is fully accessible and disability inclusive , and take measures to ensure its preparedness to provide persons with disabilities with the necessary support in the event of a disaster.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 3,
            title: 'In the light of its general comment No. 12 (2009) on the right of the child to be heard, the Committee recommends that the State party take measures to strengthen that right in accordance with article 12 of the Convention and to ensure the effective implementation of legislation recognizing the right of the child to be heard in relevant legal proceedings, including by establishing systems and/or procedures for social workers and courts to comply with the principle. The Committee also calls upon the State party to take prompt legal measures to amend chapter 1, section 11, of the Aliens Act, abolish the exception of inappropriateness, and ensure that a child is heard whenever a decision affecting him or her is made. ',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          }
        ]
      },
      {
        dateString: '12/2008',
        opened: true,
        recommendations: [
          {
            id: 0,
            title: 'The Committee encourages the State party to increase the allocation of human, technical and financial resources to helplines to provide a nationwide 24-hour service.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 1,
            title: 'The Committee recommends that the State party take all the necessary measures to enable children with parents in prison to maintain personal relations and direct contact with them, and systematically apply the principle of closeness. The Committee also encourages the State party to continue to increase child-friendly visiting facilities in prisons.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 2,
            title: 'The Committee recommends that the State party fully regulate practices relating to the removal of children from their families and ensure that removal is always subject to thorough investigation, is in accordance with the best interests of the child and is used as a measure of last resort.',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          },
          {
            id: 3,
            title: '9. The Committee reiterates its recommendation (see CCPR/C/SWE/CO/6, para. 4) that the State party establish, without undue delay, an independent national human rights institution invested with a broad human rights mandate and provide it with adequate financial and human resources, in accordance with the principles relating to the status of national institutions for the promotion and protection of human rights (the Paris Principles).',
            affectedPersons: [AFFECTED_PERSONS[1].name, AFFECTED_PERSONS[5].name, AFFECTED_PERSONS[7].name],
            affectedPersonsOpened: false,
            themes: [THEMES[3], THEMES[5], THEMES[10], THEMES[11], THEMES[14]],
            themesOpened: false,
            sdgs: [
              {
                index: 1, sugSdgIndexes: [1, 3, 5]
              },
              {
                index: 3, sugSdgIndexes: [1, 3, 5]
              },
            ],
            sdgsOpened: false,
            linked: false,
            projectIds: [1, 3, 6],
            activityIds: [3, 4, 5],
            highlighted: false
          }
        ]
      }
    ]
  }
];

export const MECHANISM_STATUSES = [
  {
    name: 'Overdue',
    icon: "fa-regular fa-stopwatch",
    color: '#FE4D55'
  },
  {
    name: 'Upcoming',
    icon: "fa-regular fa-calendar-plus",
    color: '#6DD230'
  },
  {
    name: 'Due',
    icon: "fa-regular fa-clock",
    color: '#FFAB2B'
  },
];

export const MECHANISMS = [
  {
    id: '175', 
    name: 'Special Rapporteur on the elimination of discrimination against persons affected by leprosy and their family members',
    abbreviation: 'SR Leprosy',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '174', 
    name: 'Special Rapporteur on the situation of human rights in Eritrea',
    abbreviation: 'SR on the situation of human rights in Eritrea',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '173', 
    name: 'Special Rapporteur on the situation of human rights in the Syrian Arab Republic',
    abbreviation: 'Special Rapporteur on the situation of human rights in the Syrian Arab Republic',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '171', 
    name: 'Special Rapporteur on the human rights of internally displaced persons',
    abbreviation: 'SR IDPs',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '169', 
    name: 'Independent Expert on protection against violence and discrimination based on sexual orientation and gender identity',
    abbreviation: 'IE Sexual Orientation and Gender Identity',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '167', 
    name: 'Independent Expert on protection against violence and discrimination based on sexual orientation and gender identity',
    abbreviation: 'IE Sexual Orientation & gender identity',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '165', 
    name: 'Independent Expert on the promotion of a democratic and equitable international order',
    abbreviation: 'IE Democratic and equitable international order',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '161', 
    name: 'Special Rapporteur on trafficking in persons, especially women and children',
    abbreviation: 'SR Trafficking',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '159', 
    name: 'Human Rights Committee',
    abbreviation: 'CCPR',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '157', 
    name: 'Special Rapporteur on the human right to safe drinking water and sanitation',
    abbreviation: 'SR Water & sanitation',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '155', 
    name: 'Special Rapporteur on the implications for human rights of the environmentally sound management and disposal of hazardous substances and wastes',
    abbreviation: 'SR Toxic wastes',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '153', 
    name: 'Special Rapporteur on extreme poverty and human rights',
    abbreviation: 'SR Extreme poverty',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '151', 
    name: 'Working Group of Experts on People of African descent',
    abbreviation: 'WG People of african descent',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '149', 
    name: 'Independent Expert on the situation of human rights in Central African Republic',
    abbreviation: 'IE Central African Republic',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '147', 
    name: 'Representative of the Secretary-General on the human rights of internally displaced persons',
    abbreviation: 'RSG IDPs',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '145', 
    name: 'Independent Expert on the enjoyment of all human rights by older persons',
    abbreviation: 'IE Older persons',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '143', 
    name: 'Special Rapporteur on torture and other cruel, inhuman or degrading treatment or punishment',
    abbreviation: 'SR Torture',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '141', 
    name: 'Special Rapporteur in the field of cultural rights',
    abbreviation: 'SR Cultural rights',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '139', 
    name: 'Independent Expert on the Situation of Human Rights in Côte d\'Ivoire',
    abbreviation: 'IE Côte d’Ivoire',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '137', 
    name: 'Committee on Migrant Workers',
    abbreviation: 'CMW',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '135', 
    name: 'Committee against Torture',
    abbreviation: 'CAT',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '133', 
    name: 'Special Rapporteur on the sale and sexual exploitation of children, including child prostitution, child pornography and other child sexual abuse material',
    abbreviation: 'SR Sale of children',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '131', 
    name: 'Special Rapporteur on contemporary forms of racism, racial discrimination, xenophobia and related intolerance',
    abbreviation: 'SR Racism',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '129', 
    name: 'Special Rapporteur on the promotion of truth, justice, reparation and guarantees of non-recurrence',
    abbreviation: 'SR Truth, justice, reparation',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '127', 
    name: 'Optional Protocol to the Convention on the Rights of the Child on the sale of children child prostitution and child pornography',
    abbreviation: 'CRC-OP-SC',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '125', 
    name: 'Independent Expert appointed by the Secretary-General on the situation of human rights in Somalia',
    abbreviation: 'IE Somalia',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '123', 
    name: 'Special Rapporteur on extrajudicial, summary or arbitrary executions',
    abbreviation: 'SR Summary executions',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '121', 
    name: 'Committee on the Elimination of Racial Discrimination',
    abbreviation: 'CERD',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '119', 
    name: 'Working Group on Enforced or Involuntary Disappearances',
    abbreviation: 'WG Disappearances',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '117', 
    name: 'Special Rapporteur on the issue of human rights obligations relating to the enjoyment of a safe, clean, healthy and sustainable environment',
    abbreviation: 'SR Environment',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '115', 
    name: 'Personal Representative of the High Commissioner for Human Rights on the situation of human rights in Cuba',
    abbreviation: 'PRHCHR Cuba',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '113', 
    name: 'Committee on the Rights of Persons with Disabilities',
    abbreviation: 'CRPD',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '111', 
    name: 'Special Rapporteur on the right to education',
    abbreviation: 'SR Education',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '109', 
    name: 'Special Rapporteur on adequate housing as a component of the right to an adequate standard of living',
    abbreviation: 'SR Housing',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '107', 
    name: 'Special Representative of the Secretary-General on the situation of human rights defenders',
    abbreviation: 'SRSG HR Defenders',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '105', 
    name: 'Independent Expert appointed by the Secretary-General on the situation of human rights in Haiti',
    abbreviation: 'IE Haiti',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '103', 
    name: 'Special Representative of the Secretary-General on the situation of human rights in Cambodia',
    abbreviation: 'SRSG Cambodia',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '101', 
    name: 'Joint Report',
    abbreviation: 'Joint Report',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '99', 
    name: 'Working Group on the use of mercenaries as a means of violating human rights and impeding the exercise of the right of peoples to self-determination',
    abbreviation: 'WG Mercenaries',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '97', 
    name: 'Special Rapporteur on the right to development',
    abbreviation: 'SR Development',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '95', 
    name: 'Special Rapporteur on the human rights of migrants',
    abbreviation: 'SR Migrants',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '93', 
    name: 'Special Rapporteur on the right to privacy',
    abbreviation: 'SR Privacy',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '91', 
    name: 'Special Rapporteur on the right to food',
    abbreviation: 'SR Food',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '89', 
    name: 'Working Group on the issue of discrimination against women in law and in practice',
    abbreviation: 'WG Women & girls',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '87', 
    name: 'Independent Expert on the situation of human rights in Mali',
    abbreviation: 'IE Mali',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '85', 
    name: 'No source Available',
    abbreviation: 'No Source',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '83', 
    name: 'Special Rapporteur on human rights in Cambodia',
    abbreviation: 'SR Cambodia',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '81', 
    name: 'Special Rapporteur on the rights to freedom of peaceful assembly and of association',
    abbreviation: 'SR Assembly & association',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '79', 
    name: 'Independent International Commission of Inquiry',
    abbreviation: 'Commission of Inquiry',
    mechanismType: 'Others',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '77', 
    name: 'Universal Periodic Review',
    abbreviation: 'UPR',
    mechanismType: 'Universal Periodic Review',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '75', 
    name: 'Committee on Enforced Disappearances',
    abbreviation: 'CED',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '73', 
    name: 'Ad hoc Missions',
    abbreviation: 'Ad hoc Missions',
    mechanismType: 'Others',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '71', 
    name: 'Working Group on the issue of human rights and transnational corporations and other business enterprises',
    abbreviation: 'WG Transnational corporations',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '69', 
    name: 'Independent Expert on the effects of foreign debt and other related international financial obligations of States on the full enjoyment of all human rights, particularly economic, social and cultural rights',
    abbreviation: 'IE Foreign debt',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '67', 
    name: 'Special Rapporteur on the right of everyone to the enjoyment of the highest attainable standard of physical and mental health',
    abbreviation: 'SR Health',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '65', 
    name: 'Special Rapporteur on the promotion and protection of the right to freedom of opinion and expression',
    abbreviation: 'SR Freedom of expression',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '63', 
    name: 'Special Rapporteur on the independence of judges and lawyers',
    abbreviation: 'SR Independence of judges',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '61', 
    name: 'Working Group on Arbitrary Detention',
    abbreviation: 'WG Arbitrary detention',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '59', 
    name: 'Independent Expert on human rights and international solidarity',
    abbreviation: 'IE International solidarity',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '57', 
    name: 'Special Rapporteur on the situation of human rights in the Palestinian territories occupied by Israel since 1967',
    abbreviation: 'SR OPT',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '55', 
    name: 'Independent expert on the effects of economic reform policies and foreign debt on the full enjoyment of all human rights, particularly economic, social and cultural rights',
    abbreviation: 'IE Eco. Reform & Foreign Debt',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '53', 
    name: 'Committee on the Rights of the Child',
    abbreviation: 'CRC',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '51', 
    name: 'Committee on Economic, Social and Cultural Rights',
    abbreviation: 'CESCR',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '49', 
    name: 'Special Rapporteur on the situation of human rights in the Democratic People\'s Republic of Korea',
    abbreviation: 'SR Korea',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '47', 
    name: 'Special Rapporteur on minority issues',
    abbreviation: 'SR Minorities',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '45', 
    name: 'Special Rapporteur on the situation of human rights in the Sudan',
    abbreviation: 'SR Sudan',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '43', 
    name: 'Special Rapporteur on contemporary forms of slavery, including its causes and consequences',
    abbreviation: 'SR Slavery',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '41', 
    name: 'International Fact-Finding Mission',
    abbreviation: 'Fact-Finding Mission',
    mechanismType: 'Others',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '39', 
    name: 'Special Rapporteur on violence against women, its causes and consequences',
    abbreviation: 'SR Violence against women',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '37', 
    name: 'Special Rapporteur on the promotion and protection of human rights and fundamental freedoms while countering terrorism',
    abbreviation: 'SR Countering terrorism',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '35', 
    name: 'Independent Expert on the situation of human rights in Liberia',
    abbreviation: 'IE Liberia',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '33', 
    name: 'Special Rapporteur on freedom of religion or belief',
    abbreviation: 'SR Freedom of religion',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '31', 
    name: 'Subcommittee on Prevention of Torture',
    abbreviation: 'SPT',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '29', 
    name: 'Optional Protocol to the Convention on the Rights of the Child on the involvement of children in armed conflict',
    abbreviation: 'CRC-OP-AC',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '27', 
    name: 'Independent Expert on the situation of human rights in Burundi',
    abbreviation: 'IE Burundi',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '25', 
    name: 'Special Rapporteur on the situation of human rights in Belarus',
    abbreviation: 'SR Belarus',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '23', 
    name: 'Special Rapporteur on the rights of persons with disabilities',
    abbreviation: 'SR Persons with disability',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '21', 
    name: 'Special Rapporteur on the situation of human rights in the Islamic Republic of Iran',
    abbreviation: 'SR Iran',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '19', 
    name: 'Special Rapporteur on the situation of human rights and fundamental freedoms of indigenous people',
    abbreviation: 'SR Indigenous',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '17', 
    name: 'Independent Expert on the enjoyment of human rights by persons with albinism',
    abbreviation: 'IE  Albinism',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '15', 
    name: 'Special Representative of the Secretary-General for children and armed conflict',
    abbreviation: 'SRSG Children & Armed Conflict',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '13', 
    name: 'Special Representative of the Secretary-General on the issue of human rights and transnational corporations and other business enterprises',
    abbreviation: 'SRSG Transnational Corporations',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '11', 
    name: 'Special Rapporteur on the negative impact of unilateral coercive measures on the enjoyment of human rights',
    abbreviation: 'SR Unilateral coercive measures',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '9', 
    name: 'Committee on the Elimination of Discrimination against Women',
    abbreviation: 'CEDAW',
    mechanismType: 'Treaty bodies',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '7', 
    name: 'Special Rapporteur on the situation of human rights in Myanmar',
    abbreviation: 'SR Myanmar',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '5', 
    name: 'Independent Expert on the situation of human rights in the Democratic Republic of the Congo',
    abbreviation: 'IE DRC',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '3', 
    name: 'Independent Expert on the situation of human rights in the Sudan',
    abbreviation: 'IE Sudan',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
  },
  {
    id: '1', 
    name: 'Special Rapporteur on the situation of human rights defenders',
    abbreviation: 'SR HR Defenders',
    mechanismType: 'Special procedures',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        id: 1,
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 2,
        title: 'List of Issues',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
      {
        id: 3,
        title: 'List of Issues Prior to Reporting 2',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
        points: [
          {
            id: 1,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 2,
            title: "I. General situation of women's human rights in the country",
            titleHelper: 'At sed tibique accusam commune.',
            subtitle: "1. Right to education",
            subtitleHelper: 'At sed tibique accusam commune.',
            description: "<p><strong>Question from Committee: What has been achieved in the area of eduaction?</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          },
          {
            id: 3,
            subtitle: "2. Access to the labour market",
            description: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo. Vestibulum aliquam hendrerit molestie.</p>",
            comment: '',
            opened: false,
          }
        ]
      },
    ],
    opened: false
   }
];

export const TREATY_BODIES = [
  {
    id: 1,
    name: 'Convention on the Rights of Persons with Disabilities (CRPD)',
    procedure: 'Simplified procedure',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
    ],
    opened: false
  },
  {
    id: 2,
    name: 'Convention on Enforced Disappearances (CED)',
    procedure: 'Simplified procedure',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
    ],
    opened: false
  },
  {
    id: 3,
    name: 'Convention on the Elimination of Discrimination against Women (CEDAW)',
    procedure: 'Simplified procedure',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
    ],
    opened: false
  },
  {
    id: 4,
    name: 'Covenant on Economic, Social and Cultural Rights (CESCR)',
    procedure: 'Simplified procedure',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
    ],
    opened: false
  },
  {
    id: 5,
    name: 'Covenant on Civil and Political Rights (CCPR)',
    procedure: 'Simplified procedure',
    status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
    requests: [
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
      {
        title: 'List of Issues Prior to Reporting',
        onDate: '02/21',
        byDate: '08/21',
        status: MECHANISM_STATUSES[Math.floor(MECHANISM_STATUSES.length * Math.random())],
        institution: INSTITUTIONS[Math.floor(INSTITUTIONS.length * Math.random())],
      },
    ],
    opened: false
  }
]
